import React, {Component, useEffect, useState} from 'react';
import {  Cookies } from 'react-cookie';
import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import JDate from 'jalali-date';
import Paper from '@material-ui/core/Paper';
import Moment from 'moment';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Divider from '@material-ui/core/Divider';
import NumberFormat from 'react-number-format';
import {  Redirect} from "react-router-dom";
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import HistoryIcon from '@material-ui/icons/History';
import Collapse from '@material-ui/core/Collapse';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import DetailsIcon from '@material-ui/icons/Details';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Avatar from '@material-ui/core/Avatar';
import { Lightbox } from "react-modal-image";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Snackbar from '@material-ui/core/Snackbar';
import { Alert } from '@material-ui/lab'
import FloatingLabelInput from './FloatingLabelInput';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import Calendar from 'react-modern-calendar-datepicker';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import ImageUploader from 'react-images-upload';
import LinearProgress from '@material-ui/core/LinearProgress';
import Fab from '@material-ui/core/Fab';
import VoiceOverOffIcon from '@material-ui/icons/VoiceOverOff';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import Select from 'react-select';
import InsureInformation from './InsureInformation'
import RequestConcil from "./requestcouncil";
import AddIcon from "@material-ui/icons/Add";
import * as constants from "../constants"

const styles = theme => ({
    paperrtl: {
        marginTop: theme.spacing(0),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    }
    , paper: {
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(1),
            width: theme.spacing(20),
        },
    },


});


const arrStaus=['',
    'ثبت سفارش توسط کاربر',
    'پرداخت شده توسط کاربر',
    'تغییر وضعیت به درحال بررسی',
    'برگشت سفارش به کاربر به علت مشکل ماهیتی',
    'برگشت سفارش به نماینده دیگر',
    'اعلام کسری واریزی به کاربر',
    'معلق کردن درخواست به تاریخ دیگر',
    'مشکل در عکس ها و مدارک برای صدور',
    'تغییر وضعیت به در حال صدور',
    'تغییر وضعیت به صادر شده و آماده تحویل',
    'تغییر وضعیت به تحویل شده به کاربر',
    'اضافه واریزی',
    ' نیاز به بازدید'];

class RequestDetail extends Component {
    cookies=new Cookies();
    constructor(props) {
        super(props);
        this.state = {
            menuIcon:0,
            showPaper:[true,false,false,false,false,false,false,false],
            showChangeStatus:[false,false,false,false,false,false,false,false,false,false,false,false,false],
            urlToLargeImageFile:'',
            urlToHugeImageFile:'',
            descImageFile:'',
            openImageBox:false,
            snackstr:"",
            showSnack:false,
            snackMode:"success",
            requst_suspend_desc:'',
            resource:'',
            otpCode:'',
            amountState6:0,
            amountAllCheck:0,
            selectedDayStart:"",
            selectedDayStartIns:"",
            selectedDayCheck:"",
            selectedDayEndIns:"",
            requst_ready_num_ins:"",
            requst_ready_code_yekta:"",
            requst_ready_code_insurer:"",
            requst_ready_name_insurer:"",
            requst_ready_end_price:"",
            picturesRequestReady: "",
            fileRequestReady: "",
            onSelectfileRequest: "",
            namePic:"",
            detailPic:"",
            detailFile:"",
            anchorEl:React.useState<null | HTMLElement>(null),
            loading:false,
            changeDetailReadyState:false,
            percent:0,
            optionState:'',
            selectedState:'',
            optionCity:'',
            selectedCity:'',
            optionAgent:[],
            optionClearingMode:[],
            optionEmployee:[],
            optionInstalmentMode:[],

            selectedAgent:'',
            optionState2:[{ value: '0', label: 'همه استانها'}],
            selectedState2:{ value: '0', label: 'همه استانها'},
            optionCity2:[{ value: '0', label: 'همه شهرها'}],
            selectedCity2:{ value: '0', label: 'همه شهرها'},
            optionModeDelivery:'',
            selectedModeDelivery:'',
            optionComoany:[{ value: '0', label: 'همه شرکت ها'}],
            selectedComoany:{ value: '0', label: 'همه شرکت ها'},
            requst_ready_code_penalty:0,
            selectedEmployee:'',
            selectedClearingMode:'',

        }
    }



    componentDidMount() {

        this.getoptionStateID();
        this.getoptionCompany();
        this.getoptionModeDeliveryID();
        this.getoptionEmployee();
        this.getoptionClearingMode();
        this.getoptionAgent();
        this.getoptionInstalmentMode();
        this.getrequest();

    }
    getrequest=()=>{
        const {requestState} = this.props;
        this.props.props.dispatch({
            type : 'WAITSHOW',
        })
        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if(arr.result==='ok'){

                    self.props.props.dispatch({
                        type : 'STATEREQUEST',
                        state : arr.data[0]
                    })
                }else if(arr.result==='error'){
                    self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                }
                self.props.props.dispatch({
                    type : 'WITEHIDE',
                })
            }
        }
        var fd = new FormData();
        fd.append('command', 'getrequestbyid' );
        fd.append('request_id',requestState['request_id'] );
        xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
        xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
        xhttp.send(fd);

    }

    getoptionInstalmentMode=()=>{
        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if(arr.result==='ok'){
                    var Company=[];
                    for(var k=0;k<arr.data.length;k++)
                    {
                        Company.push({ value: arr.data[k].instalment_mode_mode_id, label: arr.data[k].instalment_mode_mode_name});
                    }
                    self.setState({optionInstalmentMode : Company},()=>{
                    });
                }else if(arr.result==='error'){
                    self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                }
            }
        }
        var fd = new FormData();
        fd.append('command', 'get_instalment_mode' );
        xhttp.open("POST","https://api.rahnamayefarda.ir/api/organ");
        xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
        xhttp.send(fd);
    }


    getoptionCompany=()=>{
        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if(arr.result==='ok'){
                    var Comoany=[{ value: '0', label: 'همه شرکت های بیمه'}];
                    for(var k=0;k<arr.data.length;k++)
                    {
                        Comoany.push({ value: arr.data[k].company_id, label: arr.data[k].company_name, logo: arr.data[k].company_logo_url});
                    }
                    self.setState({optionComoany : Comoany,selectedComoany:Comoany[0]},()=>{
                    });
                }else if(arr.result==='error'){
                    self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                }
            }
        }
        var fd = new FormData();
        fd.append('command', 'get_company' );
        xhttp.open("POST","https://api.rahnamayefarda.ir/api/company");
        xhttp.send(fd);
    }

    getoptionStateID=()=>{
        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if(arr.result==='ok'){
                    var State=[];
                    var State2=[{ value: '0', label: 'همه استانها'}];

                    for(var k=0;k<arr.data.length;k++)
                    {
                        State.push({ value: arr.data[k].state_id, label: arr.data[k].state_name});
                        State2.push({ value: arr.data[k].state_id, label: arr.data[k].state_name});
                    }
                    self.setState({optionState : State,selectedState:State[0]
                        ,optionState2 : State2,selectedState2:State2[0]
                    },()=>{
                        self.getoptionCityID();
                    });
                }else if(arr.result==='error'){
                    self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                }
            }
        }
        var fd = new FormData();
        fd.append('command', 'get_state' );
        xhttp.open("POST","https://api.rahnamayefarda.ir/api/statecity");
        xhttp.send(fd);
    }

    getoptionAgent=()=>{
        const {selectedCity2,selectedState2,selectedComoany} = this.state;
        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if(arr.result==='ok'){
                    var State=[];
                    for(var k=0;k<arr.data.length;k++)
                    {
                        State.push({ value: arr.data[k].agent_id, label: arr.data[k].agent_name+' '+arr.data[k].agent_family+'-'+arr.data[k].agent_mobile,agent_status:arr.data[k].agent_status,company_id:arr.data[k].company_id});
                    }
                    self.setState({optionAgent : State});
                }else if(arr.result==='error'){
                    self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                }
            }
        }
        console.log('aaaaa');
        console.log(selectedState2.value);
        console.log(selectedCity2.value);
        console.log(selectedComoany.value);
        var fd = new FormData();
        fd.append('command', 'get_agent' );
        if(selectedState2.value!=='0'){fd.append('agent_state_id', selectedState2.value );}  //
        if(selectedCity2.value!=='0'){fd.append('agent_city_id', selectedCity2.value );}  //
        if(selectedComoany.value!=='0'){fd.append('agent_company_id', selectedComoany.value );}  //
        // fd.append('agent_city_id', 'get_agent' );
        //   fd.append('agent_company_id', 'get_agent' );

        xhttp.open("POST","https://api.rahnamayefarda.ir/api/agent");
        xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
        xhttp.send(fd);
    }
    getoptionEmployee=()=>{
        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if(arr.result==='ok'){
                    var State=[];
                    for(var k=0;k<arr.data.length;k++)
                    {
                        State.push({ value: arr.data[k].employee_id, label: arr.data[k].employee_name+" "+arr.data[k].employee_family});
                    }
                    self.setState({optionEmployee : State});
                }else if(arr.result==='error'){
                    self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                }
            }
        }

        var fd = new FormData();
        fd.append("command", "get_employee")
        xhttp.open("POST", `${constants.BASE_URL}/employee`)
        xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
        xhttp.send(fd);
    }

    getoptionClearingMode=()=>{
        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if(arr.result==='ok'){
                    var State=[];
                    for(var k=0;k<arr.data.length;k++)
                    {
                        State.push({ value: arr.data[k].request_ready_clearing_mode_id, label: arr.data[k].request_ready_clearing_mode_name});
                    }
                    self.setState({optionClearingMode : State});
                }else if(arr.result==='error'){
                    self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                }
            }
        }

        var fd = new FormData();
        fd.append('command', 'get_clearingmode' );
        xhttp.open("POST","https://api.rahnamayefarda.ir/api/statecity");
        xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
        xhttp.send(fd);
    }


    getoptionCityID=()=>{
        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if(arr.result==='ok'){
                    var State=[];
                    for(var k=0;k<arr.data.length;k++)
                    {
                        State.push({ value: arr.data[k].city_id, label: arr.data[k].city_name});
                    }
                    self.setState({optionCity : State});
                }else if(arr.result==='error'){
                    self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                }
            }
        }
        var fd = new FormData();
        fd.append('command', 'get_city' );
        fd.append('state_id', this.state.selectedState.value );
        xhttp.open("POST","https://api.rahnamayefarda.ir/api/statecity");
        xhttp.send(fd);
    }

    getoptionCityID2=()=>{
        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if(arr.result==='ok'){
                    var State=[{ value: '0', label: 'همه شهر ها'}];

                    for(var k=0;k<arr.data.length;k++)
                    {
                        State.push({ value: arr.data[k].city_id, label: arr.data[k].city_name});
                    }
                    self.setState({optionCity2 : State,selectedCity2:State[0]});
                }else if(arr.result==='error'){
                    self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                }
            }
        }
        var fd = new FormData();
        fd.append('command', 'get_city' );
        fd.append('state_id', this.state.selectedState2.value );
        xhttp.open("POST","https://api.rahnamayefarda.ir/api/statecity");
        xhttp.send(fd);
    }

    getoptionModeDeliveryID=()=>{
        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if(arr.result==='ok'){

                    var State=[];
                    for(var k=0;k<arr.data.length;k++)
                    {
                        State.push({ value: arr.data[k].delivery_mode_id, label: arr.data[k].delivery_mode_name});
                    }
                    self.setState({optionModeDelivery : State});
                }else if(arr.result==='error'){
                    self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                }
            }
        }
        var fd = new FormData();
        fd.append('command', 'get_mode_delivery' );
        xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
        xhttp.send(fd);
    }


    setImageModel=(image,largimage,desc)=>{
        this.setState({
            urlToLargeImageFile:largimage,
            urlToHugeImageFile:image,
            descImageFile:desc,
            openImageBox:true
        });
    }

    closeLightbox = () => {
        this.setState({
            openImageBox:false
        });
    }

    handleClick = (event) => {
        this.setState({
            anchorEl:event.currentTarget,
            //  menuIcon:6,
            //  showPaper:[false,false,false,false,false,true]
        });
    }



    changeSatus3=(request_id,agent_id)=>{
        if(this.cookies.get('employee_token_str')){
            this.props.props.dispatch({
                type : 'WAITSHOW',
            })
            var self = this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText);
                    if(arr.result==='ok'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"success" ,
                            showPaper:[true,false,false,false,false,false,false,false],
                            showChangeStatus:[false,false,false,false,false,false,false,false,false,false,false,false,false],
                        });
                        self.props.props.dispatch({
                            type : 'STATEREQUEST',
                            state : arr.data[0],
                        })
                    }else if(arr.result==='error'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }
                    self.props.props.dispatch({
                        type : 'WITEHIDE',
                    })
                }
            }
            var fd = new FormData();
            fd.append('command', 'requestpending3' );
            fd.append('request_id', request_id );
            fd.append('agent_id', agent_id );

            xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
            xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
            xhttp.send(fd);
        }else {
        }
        this.setState({
            anchorEl:null
        });
    }


    changeSatus4=(request_id,agent_id)=>{
        console.log("333333333333333333333333333333333333333333333333333333333")

        this.props.props.dispatch({
                type : 'WAITSHOW',
            })
            var self = this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText);
                    if(arr.result==='ok'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"success"  ,
                            showPaper:[true,false,false,false,false,false,false,false],
                            showChangeStatus:[false,false,false,false,false,false,false,false,false,false,false,false,false]
                        });

                        self.props.props.dispatch({
                            type : 'STATEREQUEST',
                            state : arr.data[0],
                        })
                    }else if(arr.result==='error'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }
                    self.props.props.dispatch({
                        type : 'WITEHIDE',
                    })
                }
            }
            var fd = new FormData();
            fd.append('command', 'requestbackuser4' );
            fd.append('request_id', request_id );
            fd.append('agent_id', agent_id );
            fd.append('request_backuser_desc', this.state.resource );

            xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
            xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
            xhttp.send(fd);

    }
    cancelRequest=(request_id,agent_id)=>{
        console.log("dsadasdasdsadsadsassssssssssssssssssssssssssssssssssssssssssssssss")
        if(this.state.resource!==''){
        const {requestState} = this.props;
        if(requestState["organ_id"]===15||requestState["organ_id"]==='15') {
            this.cancelRquestEtma(request_id,agent_id);
        }else{
            this.changeSatus4(request_id,agent_id);
        }
        }else {
            this.setState({ snackstr: "لطفا علت بازگشت را وارد نمایید",showSnack:true,snackMode:"error" });
        }
    }


    changeRquestEtma=(user_id,amount,request_id)=>{

            this.props.props.dispatch({
                type : 'WAITSHOW',
            })
            var self = this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText);
                    if(arr.result==='ok'){
                        if(arr.data.status==="FAILED")
                        {
                            self.setState({ snackstr:arr.data.error.message,showSnack:true,snackMode:"error" });
                        }else if(arr.data.status==="DONE") {
                            self.getCreadit(user_id,amount,request_id);
                        }
                    }else if(arr.result==='error'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }
                    self.props.props.dispatch({
                        type : 'WITEHIDE',
                    })
                }
            }
            var fd = new FormData();
            fd.append('command', 'cancelrequestetma' );
            fd.append('request_id', request_id );

            xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
            xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
            xhttp.send(fd);
    }

    getCreadit=(user_id,amount,request_id)=>{
            this.props.props.dispatch({
                type : 'WAITSHOW',
            })
            var self = this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText);
                    if(arr.result==='ok'){
                        console.log(arr.data.remainingCredit);
                        console.log(amount);
                        if(arr.data.remainingCredit>=amount){
self.changeToken(user_id,amount,arr.data.token,request_id,arr.data.creditId);
                        }else{
                            self.setState({ snackstr: "مبلغ درخواست از اعتبار مشتری بیشتر است",showSnack:true,snackMode:"error" });
                        }
                    }else if(arr.result==='error'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }
                    self.props.props.dispatch({
                        type : 'WITEHIDE',
                    })
                }
            }
            var fd = new FormData();
            fd.append('command', 'creditinquiry' );
        fd.append('user_id', user_id);

        xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
            xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
            xhttp.send(fd);

    }
    changeToken=(user_id,amount,token,request_id,creditId)=>{
        this.props.props.dispatch({
            type : 'WAITSHOW',
        })
        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if(arr.result==='ok'){
                    self.sendOtp(user_id,amount,token,request_id,creditId);
                }else if(arr.result==='error'){
                    self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                }
                self.props.props.dispatch({
                    type : 'WITEHIDE',
                })
            }
        }
        var fd = new FormData();
        fd.append('command', 'changetoken' );
        fd.append('token', token);
        fd.append('request_id', request_id);
        xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
        xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
        xhttp.send(fd);

    }
    sendOtp=(user_id,amount,token,request_id,creditId)=>{
        this.props.props.dispatch({
            type : 'WAITSHOW',
        })
        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if(arr.result==='ok'){

                }else if(arr.result==='error'){
                    self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                }
                self.props.props.dispatch({
                    type : 'WITEHIDE',
                })
            }
        }
        var fd = new FormData();
        fd.append('command', 'credittransaction' );
        fd.append('token_transaction', token);
        fd.append('creditId', creditId);
        fd.append('amount', amount);
        fd.append('user_id', user_id);
        xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
        xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
        xhttp.send(fd);

    }
    checkOtp=(user_id,amount,request_id)=>{
        this.props.props.dispatch({
            type : 'WAITSHOW',
        })
        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if(arr.result==='ok'){

                   self.setTrackingCode(arr.data.trackingCode,arr.data.transactionAmount,request_id);
                    self.setState({ snackstr: "قیمت درخواست در سایت اتما به روزرسانی شد",showSnack:true,snackMode:"success" });
                }else if(arr.result==='error'){
                    self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                }
                self.props.props.dispatch({
                    type : 'WITEHIDE',
                })
            }
        }
        var fd = new FormData();
        fd.append('command', 'checkcredittransaction' );;
        fd.append('otp', this.state.otpCode);
        fd.append('request_id', request_id);
        fd.append('amount', amount);
        fd.append('user_id', user_id);
        xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
        xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
        xhttp.send(fd);

    }

    setTrackingCode=(trackingcode,amount,request_id)=>{
        this.props.props.dispatch({
            type : 'WAITSHOW',
        })
        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if(arr.result==='ok'){

                }else if(arr.result==='error'){
                    self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                }
                self.props.props.dispatch({
                    type : 'WITEHIDE',
                })
            }
        }
        var fd = new FormData();
        fd.append('command', 'changerequest' );;
        fd.append('organ_request_id', request_id);
        fd.append('organ_request_trackingcode', trackingcode);
        fd.append('organ_request_amount', amount);
        xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
        xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
        xhttp.send(fd);

    }

    cancelRquestEtma=(request_id,agent_id)=>{
        if(this.state.resource!==''){
            this.props.props.dispatch({
                type : 'WAITSHOW',
            })
            var self = this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText);
                    if(arr.result==='ok'){
                         if(arr.data.status==="FAILED")
                        {
                            self.setState({ snackstr:arr.data.error.message,showSnack:true,snackMode:"error" });
                        }else if(arr.data.status==="DONE") {
                             self.changeSatus4(request_id, agent_id);
                         }
                    }else if(arr.result==='error'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }
                    self.props.props.dispatch({
                        type : 'WITEHIDE',
                    })
                }
            }
            var fd = new FormData();
            fd.append('command', 'cancelrequestetma' );
            fd.append('request_id', request_id );

            xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
            xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
            xhttp.send(fd);
        }else {
            this.setState({ snackstr: "لطفا علت بازگشت را وارد نمایید",showSnack:true,snackMode:"error" });
        }
    }

    changeSatus5=(request_id,agent_id)=>{
        if(this.state.resource!==''){
            this.props.props.dispatch({
                type : 'WAITSHOW',
            })
            var self = this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText);
                    if(arr.result==='ok'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"success"  ,
                            showPaper:[true,false,false,false,false,false,false,false],
                            showChangeStatus:[false,false,false,false,false,false,false,false,false,false,false,false,false]
                        });
                        self.props.props.dispatch({
                            type : 'STATEREQUEST',
                            state : arr.data[0],
                        })
                    }else if(arr.result==='error'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }
                    self.props.props.dispatch({
                        type : 'WITEHIDE',
                    })
                }
            }
            var fd = new FormData();
            fd.append('command', 'requestbackagent5' );
            fd.append('request_id', request_id );
            fd.append('newagent_id', this.state.selectedAgent.value );
            fd.append('agent_id', agent_id );

            console.log(this.state.selectedAgent.company_id);
            fd.append('company_id', this.state.selectedAgent.company_id );
            fd.append('request_backuser_desc', this.state.resource );

            xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
            xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
            xhttp.send(fd);
        }else {
            this.setState({ snackstr: "لطفا علت بازگشت را وارد نمایید",showSnack:true,snackMode:"error" });
        }
    }


    changeSatus6=(request_id,agent_id)=>{
        if(this.state.resource!==''&&this.state.amountState6!==0&&this.state.amountState6!==''){
            this.props.props.dispatch({
                type : 'WAITSHOW',
            })
            var self = this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText);
                    if(arr.result==='ok'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"success"  ,
                            showPaper:[true,false,false,false,false,false,false,false],
                            showChangeStatus:[false,false,false,false,false,false,false,false,false,false,false,false,false]
                        });
                        self.props.props.dispatch({
                            type : 'STATEREQUEST',
                            state : arr.data[0]
                        })
                    }else if(arr.result==='error'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }
                    self.props.props.dispatch({
                        type : 'WITEHIDE',
                    })
                }
            }
            var fd = new FormData();
            fd.append('command', 'requestdepositdeficit6' );
            fd.append('request_id', request_id );
            fd.append('agent_id', agent_id );
            fd.append('deficit_pey_reason', this.state.resource );
            fd.append('deficit_pey_amount', this.state.amountState6 );

            xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
            xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
            xhttp.send(fd);
        }else {
            this.setState({ snackstr: "لطفا علت کسری واریزی و مبلغ آن را وارد نمایید",showSnack:true,snackMode:"error" });
        }
    }

    changeSatus7=(request_id,agent_id)=>{
        if(this.state.resource!==''&&this.state.selectedDayStart!==""){

            this.props.props.dispatch({
                type : 'WAITSHOW',
            })
            var self = this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText);
                    if(arr.result==='ok'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"success"  ,
                            showPaper:[true,false,false,false,false,false,false,false],
                            showChangeStatus:[false,false,false,false,false,false,false,false,false,false,false,false,false]
                        });
                        self.props.props.dispatch({
                            type : 'STATEREQUEST',
                            state : arr.data[0]
                        })
                    }else if(arr.result==='error'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }
                    self.props.props.dispatch({
                        type : 'WITEHIDE',
                    })
                }
            }
            var fd = new FormData();
            fd.append('command', 'requestsuspend7' );
            fd.append('request_id', request_id );
            fd.append('agent_id', agent_id );
            fd.append('requst_suspend_desc', this.state.resource );
            fd.append('requst_suspend_end_date', Moment(JDate.toGregorian(this.state.selectedDayStart.year, this.state.selectedDayStart.month, this.state.selectedDayStart.day)).format('YYYY-MM-DD h:mm:ss') );

            xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
            xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
            xhttp.send(fd);

        }else {
            this.setState({ snackstr: "لطفا علت تعلیق صدور و تاریخ یادآوری را وارد نمایید ",showSnack:true,snackMode:"error" });
        }
    }


    changeSatus8=(request_id,agent_id)=>{
        if(this.state.resource!==''){
            this.props.props.dispatch({
                type : 'WAITSHOW',
            })
            var self = this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText);
                    if(arr.result==='ok'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"success" ,
                            showPaper:[true,false,false,false,false,false,false,false],
                            showChangeStatus:[false,false,false,false,false,false,false,false,false,false,false,false,false]
                        });
                        self.props.props.dispatch({
                            type : 'STATEREQUEST',
                            state : arr.data[0],
                        })
                    }else if(arr.result==='error'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }
                    self.props.props.dispatch({
                        type : 'WITEHIDE',
                    })
                }
            }
            var fd = new FormData();
            fd.append('command', 'requestdifficult8' );
            fd.append('request_id', request_id );
            fd.append('agent_id', agent_id );
            fd.append('request_difficult_desc', this.state.resource );

            xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
            xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
            xhttp.send(fd);
        }else {
            this.setState({ snackstr: "لطفا مشکل مدارک را ذکر نمایید",showSnack:true,snackMode:"error" });
        }
    }



    changeSatus9=(request_id,agent_id)=>{
        if(this.cookies.get('employee_token_str')){
            this.props.props.dispatch({
                type : 'WAITSHOW',
            })
            var self = this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText);
                    if(arr.result==='ok'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"success"  ,
                            showPaper:[true,false,false,false,false,false,false,false],
                            showChangeStatus:[false,false,false,false,false,false,false,false,false,false,false,false,false]
                        });
                        self.props.props.dispatch({
                            type : 'STATEREQUEST',
                            state : arr.data[0]
                        })
                    }else if(arr.result==='error'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }
                    self.props.props.dispatch({
                        type : 'WITEHIDE',
                    })
                }
            }
            var fd = new FormData();
            fd.append('command', 'requestissuing9' );
            fd.append('request_id', request_id );
            fd.append('agent_id', agent_id );

            xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
            xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
            xhttp.send(fd);
        }else {
        }
        this.setState({
            anchorEl:null
        });
    }


    changeSatus10=(request_id,agent_id)=>{
        const {requst_suspend_desc,selectedDayStartIns,selectedDayEndIns,requst_ready_num_ins,requst_ready_code_rayane,requst_ready_code_penalty,requst_ready_code_yekta,requst_ready_code_insurer,requst_ready_name_insurer,requst_ready_end_price,selectedClearingMode} = this.state;
        const {requestState} = this.props;
//fdsfdsfdsfdsfdsf
        if(selectedDayStartIns!==""&&selectedDayEndIns!==""&&requst_ready_num_ins!==""&&requst_ready_code_rayane!==""&&requst_ready_code_penalty!==""&&requst_ready_code_yekta!==""&&requst_ready_code_insurer!==""&&requst_ready_name_insurer!==""&&requst_ready_end_price&&selectedClearingMode&&selectedClearingMode!='') {
            if (requestState['user_pey_amount']-requst_ready_end_price  > 0) {
                console.log('dddddddd',requestState['user_pey_amount']-requst_ready_end_price)
                this.setState({ snackstr: 'درخواست را نمی توانید به حالت صدور در آوورید به علت اضافه واریزی به مبلغ: '+(requestState['user_pey_amount']-requst_ready_end_price),showSnack:true,snackMode:"error" });
            } else
            if (requst_ready_end_price-requestState['user_pey_amount']  >100000) {
                console.log('iooooooo',requst_ready_end_price - requestState['user_pey_amount'])
                this.setState({ snackstr: 'درخواست را نمی توانید به حالت صدور در آوورید به علت کسری واریزی به مبلغ: '+(requst_ready_end_price-requestState['user_pey_amount']),showSnack:true,snackMode:"error" });

            } else{
                this.props.props.dispatch({
                    type: 'WAITSHOW',
                })
                var self = this;
                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function () {
                    if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText);
                        if (arr.result === 'ok') {
                            self.setState({
                                snackstr: arr.desc, showSnack: true, snackMode: "success",
                            });
                            self.props.props.dispatch({
                                type: 'STATEREQUEST',
                                state: arr.data[0]
                            })
                        } else if (arr.result === 'error') {
                            self.setState({snackstr: arr.desc, showSnack: true, snackMode: "error"});
                        }
                        self.props.props.dispatch({
                            type: 'WITEHIDE',
                        })
                    }
                }
                var fd = new FormData();
                fd.append('command', 'requestready10');
                fd.append('request_id', request_id);
                fd.append('agent_id', agent_id);
                fd.append('requst_suspend_desc', requst_suspend_desc);
                fd.append('requst_ready_end_price', requst_ready_end_price);
                fd.append('requst_ready_num_ins', requst_ready_num_ins);
                fd.append('requst_ready_code_yekta', requst_ready_code_yekta);
                fd.append('requst_ready_code_penalty', requst_ready_code_penalty);
                fd.append('requst_ready_code_rayane', requst_ready_code_rayane);
                fd.append('requst_ready_name_insurer', requst_ready_name_insurer);
                fd.append('requst_ready_code_insurer', requst_ready_code_insurer);
                fd.append('request_ready_clearing_id', selectedClearingMode.value);
                fd.append('requst_ready_start_date', Moment(JDate.toGregorian(selectedDayStartIns.year, selectedDayStartIns.month, selectedDayStartIns.day)).format('YYYY-MM-DD h:mm:ss'));
                fd.append('requst_ready_end_date', Moment(JDate.toGregorian(selectedDayEndIns.year, selectedDayEndIns.month, selectedDayEndIns.day)).format('YYYY-MM-DD h:mm:ss'));

                xhttp.open("POST", "https://api.rahnamayefarda.ir/api/employeerequestreport");
                xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
                xhttp.send(fd);

            }
        }
        else
        {
            this.setState({snackstr: "لطفا مشخصات صدور را تکمیل نمایید ", showSnack: true, snackMode: "error"});
        }
    }


    changeSatusReady=(request_id,agent_id)=>{
        const {requst_suspend_desc,selectedDayStartIns,selectedDayEndIns,requst_ready_num_ins,requst_ready_code_rayane,requst_ready_code_penalty,requst_ready_code_yekta,requst_ready_code_insurer,requst_ready_name_insurer,requst_ready_end_price,selectedEmployee,selectedClearingMode} = this.state;
        const {requestState} = this.props;
//fdsfdsfdsfdsfdsf
        if(selectedDayStartIns!==""&&selectedDayEndIns!==""&&requst_ready_num_ins!==""&&requst_ready_code_rayane!==""&&requst_ready_code_penalty!==""&&requst_ready_code_yekta!==""&&requst_ready_code_insurer!==""&&requst_ready_name_insurer!==""&&requst_ready_end_price&&selectedClearingMode&&selectedClearingMode!=''&&selectedEmployee&&selectedEmployee!='') {
            if (requestState['user_pey_amount']-requst_ready_end_price  > 0) {
                console.log('dddddddd',requestState['user_pey_amount']-requst_ready_end_price)
                this.setState({ snackstr: 'درخواست را نمی توانید به حالت صدور در آوورید به علت اضافه واریزی به مبلغ: '+(requestState['user_pey_amount']-requst_ready_end_price),showSnack:true,snackMode:"error" });
            } else
            if (requst_ready_end_price-requestState['user_pey_amount']  >70000) {
                console.log('iooooooo',requst_ready_end_price - requestState['user_pey_amount'])
                this.setState({ snackstr: 'درخواست را نمی توانید به حالت صدور در آوورید به علت کسری واریزی به مبلغ: '+(requst_ready_end_price-requestState['user_pey_amount']),showSnack:true,snackMode:"error" });

            } else{
                this.props.props.dispatch({
                    type: 'WAITSHOW',
                })
                var self = this;
                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function () {
                    if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText);
                        if (arr.result === 'ok') {
                            self.setState({
                                snackstr: arr.desc, showSnack: true, snackMode: "success",
                            });
                            self.props.props.dispatch({
                                type: 'STATEREQUEST',
                                state: arr.data[0]
                            })
                        } else if (arr.result === 'error') {
                            self.setState({snackstr: arr.desc, showSnack: true, snackMode: "error"});
                        }
                        self.props.props.dispatch({
                            type: 'WITEHIDE',
                        })
                    }
                }
                var fd = new FormData();
                fd.append('command', 'modifyrequestready');
                fd.append('request_id', request_id);
                fd.append('agent_id', agent_id);
                fd.append('requst_suspend_desc', requst_suspend_desc);
                fd.append('requst_ready_end_price', requst_ready_end_price);
                fd.append('requst_ready_num_ins', requst_ready_num_ins);
                fd.append('requst_ready_code_yekta', requst_ready_code_yekta);
                fd.append('requst_ready_code_penalty', requst_ready_code_penalty);
                fd.append('requst_ready_code_rayane', requst_ready_code_rayane);
                fd.append('requst_ready_name_insurer', requst_ready_name_insurer);
                fd.append('requst_ready_code_insurer', requst_ready_code_insurer);
                fd.append('request_ready_clearing_id', selectedClearingMode.value);
                fd.append('requst_ready_employee_id', selectedEmployee.value);
                fd.append('requst_ready_start_date', Moment(JDate.toGregorian(selectedDayStartIns.year, selectedDayStartIns.month, selectedDayStartIns.day)).format('YYYY-MM-DD h:mm:ss'));
                fd.append('requst_ready_end_date', Moment(JDate.toGregorian(selectedDayEndIns.year, selectedDayEndIns.month, selectedDayEndIns.day)).format('YYYY-MM-DD h:mm:ss'));

                xhttp.open("POST", "https://api.rahnamayefarda.ir/api/employeerequestreport");
                xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
                xhttp.send(fd);

            }
        }
        else
        {
            this.setState({snackstr: "لطفا مشخصات صدور را تکمیل نمایید ", showSnack: true, snackMode: "error"});
        }
    }


    changeSatus12=(request_id,agent_id,user_id)=>{
        if(this.state.resource!==''&&this.state.amountState6!==0&&this.state.amountState6!==''){
            this.props.props.dispatch({
                type : 'WAITSHOW',
            })
            var self = this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText);
                    if(arr.result==='ok'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"success"  ,
                            showPaper:[true,false,false,false,false,false,false,false],
                            showChangeStatus:[false,false,false,false,false,false,false,false,false,false,false,false,false]
                        });
                        self.props.props.dispatch({
                            type : 'STATEREQUEST',
                            state : arr.data[0]
                        })
                    }else if(arr.result==='error'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }
                    self.props.props.dispatch({
                        type : 'WITEHIDE',
                    })
                }
            }
            var fd = new FormData();
            fd.append('command', 'requestoverpayment12' );
            fd.append('request_id', request_id );
            fd.append('agent_id', agent_id );
            fd.append('user_id', user_id );
            fd.append('overpayment_reason', this.state.resource );
            fd.append('overpayment_amount', this.state.amountState6 );

            xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
            xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
            xhttp.send(fd);
        }else {
            this.setState({ snackstr: "لطفا علت کسری واریزی و مبلغ آن را وارد نمایید",showSnack:true,snackMode:"error" });
        }
    }


    changeSatusfrom6=(request_id,agent_id)=>{
        if(this.cookies.get('employee_token_str')){
            this.props.props.dispatch({
                type : 'WAITSHOW',
            })
            var self = this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText);
                    if(arr.result==='ok'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"success"  ,
                            showPaper:[true,false,false,false,false,false,false,false],
                            showChangeStatus:[false,false,false,false,false,false,false,false,false,false,false,false,false]
                        });
                        self.props.props.dispatch({
                            type : 'STATEREQUEST',
                            state : arr.data[0]
                        })
                    }else if(arr.result==='error'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }
                    self.props.props.dispatch({
                        type : 'WITEHIDE',
                    })
                }
            }
            var fd = new FormData();
            fd.append('command', 'requestdeletedepositdeficit6' );
            fd.append('request_id', request_id );
            fd.append('agent_id', agent_id );

            xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
            xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
            xhttp.send(fd);
        }else {
        }
        this.setState({
            anchorEl:null
        });
    }


    changeSatusfrom16=(request_id,agent_id)=>{
        if(this.cookies.get('employee_token_str')){
            this.props.props.dispatch({
                type : 'WAITSHOW',
            })
            var self = this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText);
                    if(arr.result==='ok'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"success"  ,
                            showPaper:[true,false,false,false,false,false,false,false],
                            showChangeStatus:[false,false,false,false,false,false,false,false,false,false,false,false,false]
                        });
                        self.props.props.dispatch({
                            type : 'STATEREQUEST',
                            state : arr.data[0]
                        })
                    }else if(arr.result==='error'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }
                    self.props.props.dispatch({
                        type : 'WITEHIDE',
                    })
                }
            }
            var fd = new FormData();
            fd.append('command', 'requestvisit16' );
            fd.append('request_id', request_id );
            fd.append('agent_id', agent_id );

            xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
            xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
            xhttp.send(fd);
        }else {
        }
        this.setState({
            anchorEl:null
        });
    }
    changeDeleteSatusfrom16=(request_id,agent_id)=>{
        if(this.cookies.get('employee_token_str')){
            this.props.props.dispatch({
                type : 'WAITSHOW',
            })
            var self = this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText);
                    if(arr.result==='ok'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"success"  ,
                            showPaper:[true,false,false,false,false,false,false,false],
                            showChangeStatus:[false,false,false,false,false,false,false,false,false,false,false,false,false]
                        });
                        self.props.props.dispatch({
                            type : 'STATEREQUEST',
                            state : arr.data[0]
                        })
                    }else if(arr.result==='error'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }
                    self.props.props.dispatch({
                        type : 'WITEHIDE',
                    })
                }
            }
            var fd = new FormData();
            fd.append('command', 'requestdeletevisit16' );
            fd.append('request_id', request_id );
            fd.append('agent_id', agent_id );

            xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
            xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
            xhttp.send(fd);
        }else {
        }
        this.setState({
            anchorEl:null
        });
    }


    showChangeStatus3= (event) => {
        this.setState({
            anchorEl:null,
            menuIcon:6,
            showPaper:[false,false,false,false,false,true,false,false],
            showChangeStatus:[false,false,false,true,false,false,false,false,false,false,false,false,false],
            resource:'',
        });
    }


    showChangeStatus4= (event) => {
        this.setState({
            anchorEl:null,
            menuIcon:6,
            showPaper:[false,false,false,false,false,true,false,false],
            showChangeStatus:[false,false,false,false,true,false,false,false,false,false,false,false,false],
            resource:'',
        });
    }
    showChangeStatus5= (event) => {
        this.setState({
            anchorEl:null,
            menuIcon:6,
            showPaper:[false,false,false,false,false,true,false,false],
            showChangeStatus:[false,false,false,false,false,true,false,false,false,false,false,false,false],
            resource:'',
        });
    }
    showChangeStatus6= (event) => {
        this.setState({
            anchorEl:null,
            menuIcon:6,
            showPaper:[false,false,false,false,false,true,false,false],
            showChangeStatus:[false,false,false,false,false,false,true,false,false,false,false,false,false],
            resource:'',
            amountState6:0,
        });
    }
    showChangeStatus12= (event) => {
        this.setState({
            anchorEl:null,
            menuIcon:6,
            showPaper:[false,false,false,false,false,true,false,false],
            showChangeStatus:[false,false,false,false,false,false,false,false,false,false,false,false,true],
            resource:'',
            amountState6:0,
        });
    }

    showChangeStatus7= (event) => {
        this.setState({
            anchorEl:null,
            menuIcon:6,
            showPaper:[false,false,false,false,false,true,false,false],
            showChangeStatus:[false,false,false,false,false,false,false,true,false,false,false,false,false],
            resource:'',
        });
    }
    showChangeStatus8= (event) => {
        this.setState({
            anchorEl:null,
            menuIcon:6,
            showPaper:[false,false,false,false,false,true,false,false],
            showChangeStatus:[false,false,false,false,false,false,false,false,true,false,false,false,false],
            resource:'',
        });
    }
    showChangeStatus10= (event) => {
        this.setState({
            anchorEl:null,
            menuIcon:6,
            showPaper:[false,false,false,false,false,true,false,false],
            showChangeStatus:[false,false,false,false,false,false,false,false,false,false,true,false,false],
            resource:'',
        });
    }

    showChangeStatus11= (event) => {
        this.setState({
            anchorEl:null,
            menuIcon:6,
            showPaper:[false,false,false,false,false,true,false,false],
            showChangeStatus:[false,false,false,false,false,false,false,false,false,false,false,true,false],
            resource:'',
        });
    }
    changeDetailReady=()=>{
        const {requestState} = this.props;
        const {optionClearingMode,optionEmployee} = this.state;
        var request_ready;
        if(requestState['request_ready']){
            request_ready=requestState['request_ready'][0];
        }
        var jdate1 = "",
            jdate2 = ""
        if (request_ready.requst_ready_start_date !== "") {
            var varmoment1 = Moment(request_ready.requst_ready_start_date, "YYYY-M-D HH:mm:ss")
            var date1 = new Date(parseInt(varmoment1.format("x")))
            jdate1 = new JDate(date1)
            jdate1 = { day: parseInt(jdate1.format("DD")), month: parseInt(jdate1.format("MM")), year: parseInt(jdate1.format("YYYY")) }
        }
        if (request_ready.requst_ready_end_date !== "") {
            var varmoment2 = Moment(request_ready.requst_ready_end_date, "YYYY-M-D HH:mm:ss")
            var date2 = new Date(parseInt(varmoment2.format("x")))
            jdate2 = new JDate(date2)
            jdate2 = { day: parseInt(jdate2.format("DD")), month: parseInt(jdate2.format("MM")), year: parseInt(jdate2.format("YYYY")) }
        }
        console.log(request_ready)
        console.log(request_ready)
        this.setState({
            changeDetailReadyState:true,
            requst_suspend_desc:request_ready.requst_suspend_desc,
            requst_ready_end_price:request_ready.requst_ready_end_price,
            requst_ready_num_ins:request_ready.requst_ready_num_ins,
            requst_ready_code_yekta:request_ready.requst_ready_code_yekta,
            requst_ready_code_penalty:request_ready.requst_ready_code_penalty,
            requst_ready_code_rayane:request_ready.requst_ready_code_rayane,
            requst_ready_name_insurer:request_ready.requst_ready_name_insurer,
            requst_ready_code_insurer:request_ready.requst_ready_code_insurer,
            selectedClearingMode:optionClearingMode.find((x) => x.value === request_ready.request_ready_clearing_id) ,
            selectedEmployee:optionEmployee.find((x) => x.value === request_ready.requst_ready_employee_id) ,
            selectedDayStartIns:jdate1,
            selectedDayEndIns:jdate2,

        });

        this.showChangeStatus10();
    }
    showInsertImage= (event) => {
        this.setState({
            anchorEl:null,
            menuIcon:6,
            showPaper:[false,false,false,false,false,false,true,false],
            showChangeStatus:[false,false,false,false,false,false,false,false,false,false,false,false,false],
            resource:'',
        });
    }

    handleClickcloseTasckBar= (event) => {
        this.setState({ showSnack:false });
    }

    handleClose=(event)=>{
        this.setState({
            anchorEl:null
        });
    }
    setValueMenuIcon=(event,newValue)=>{
        var temp=[false,false,false,false,false,false,false,false];
        temp[newValue]=true;
        this.setState({
            menuIcon:newValue,
            showPaper:temp
        });
    }
    handleInsuranceNum= (event) => {
        this.setState({ requst_ready_num_ins:event.target.value });
    }
    handleInsurancePenalty= (event) => {
        this.setState({ requst_ready_code_penalty:event });
    }

    handleInsuranceRayane= (event) => {
        this.setState({ requst_ready_code_rayane:event.target.value });
    }

    handleInsuranceYekta= (event) => {
        this.setState({ requst_ready_code_yekta:event.target.value });
    }
    handleInsuranceCodeInsurer= (event) => {
        this.setState({ requst_ready_code_insurer:event });
    }
    handleInsuranceNameInsurer= (event) => {
        this.setState({ requst_ready_name_insurer:event.target.value });
    }

    handleInsurancePrice= (event) => {
        this.setState({ requst_ready_end_price:event });
    }

    handleChangeNamePic = (event) => {
        this.setState({ namePic:event.target.value });
    }

    handleChangeDetailPic = (event) => {
        this.setState({ detailPic:event.target.value });
    }

    handleChangeDetailFile = (event) => {
        this.setState({ detailFile:event.target.value });
    }

    handleChangeResorce = (event) => {
        this.setState({ resource:event.target.value });
    }

    handleRequstSuspendDesc = (event) => {
        this.setState({ requst_suspend_desc:event.target.value });
    }
    changeDateNumChake= (row,request_id) => {
        if((row.instalment_check_num!==null&&row.instalment_check_num!=='')||(row.instalment_check_date!==""&&row.instalment_check_date!==null)){
            this.props.props.dispatch({
                type : 'WAITSHOW',
            })
            var self = this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText);
                    console.log(arr);
                    if(arr.result==='ok'){

                        self.props.props.dispatch({
                            type : 'STATEREQUEST',
                            state : arr.data[0]
                        })
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"success" });
                    }else if(arr.result==='notok'){

                        self.props.props.dispatch({
                            type : 'STATEREQUEST',
                            state : arr.data[0]
                        })
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }else if(arr.result==='error'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }
                    self.props.props.dispatch({
                        type : 'WITEHIDE',
                    })
                }
            }
            var fd = new FormData();
            fd.append('command', 'changedatenumcheck' );
            fd.append('instalment_check_num', row.instalment_check_num );
            fd.append('instalment_check_amount', row.user_pey_amount );
            if(row.instalment_check_date===""||row.instalment_check_date===null){
                fd.append('instalment_check_date','');
            }else {
                fd.append('instalment_check_date',  row.instalment_check_date );
            }
            fd.append('user_pey_id', row.user_pey_id );
            fd.append('request_id', request_id );

            xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
            xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
            xhttp.send(fd);
        }else {
            this.setState({ snackstr: "لطفا تاریخ یا شماره چک را وارد نمایید",showSnack:true,snackMode:"error" });
        }
    }

    deleteDateNumChake= (row,request_id) => {
        if((row.instalment_check_num!==null&&row.instalment_check_num!=='')||(row.instalment_check_date!==""&&row.instalment_check_date!==null)){
            this.props.props.dispatch({
                type : 'WAITSHOW',
            })
            var self = this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText);
                    console.log(arr);
                    if(arr.result==='ok'){

                        self.props.props.dispatch({
                            type : 'STATEREQUEST',
                            state : arr.data[0]
                        })
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"success" });
                    }else if(arr.result==='notok'){

                        self.props.props.dispatch({
                            type : 'STATEREQUEST',
                            state : arr.data[0]
                        })
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }else if(arr.result==='error'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }
                    self.props.props.dispatch({
                        type : 'WITEHIDE',
                    })
                }
            }
            var fd = new FormData();
            fd.append('command', 'deletecheck' );

            fd.append('user_pey_id', row.user_pey_id );
            fd.append('request_id', request_id );

            xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
            xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
            xhttp.send(fd);
        }else {
            this.setState({ snackstr: "لطفا تاریخ یا شماره چک را وارد نمایید",showSnack:true,snackMode:"error" });
        }
    }

    changeNewChake= (row,request_id) => {
        console.log(row,request_id)
        if((row.instalment_check_num!==null&&row.instalment_check_num!=='')||(row.instalment_check_date!==""&&row.instalment_check_date!==null)){
            this.props.props.dispatch({
                type : 'WAITSHOW',
            })
            var self = this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText);
                    console.log(arr);
                    if(arr.result==='ok'){

                        self.props.props.dispatch({
                            type : 'STATEREQUEST',
                            state : arr.data[0]
                        })
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"success" });
                    }else if(arr.result==='notok'){

                        self.props.props.dispatch({
                            type : 'STATEREQUEST',
                            state : arr.data[0]
                        })
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }else if(arr.result==='error'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }
                    self.props.props.dispatch({
                        type : 'WITEHIDE',
                    })
                }
            }
            var fd = new FormData();
            fd.append('command', 'addcheck' );
            fd.append('instalment_check_num', row.instalment_check_num );
            fd.append('instalment_check_amount', row.user_pey_amount );
            fd.append('instalment_check_desc', row.user_pey_desc );
            fd.append('instalment_check_mode', row.installment_mode.value );
            if(row.instalment_check_date===""||row.instalment_check_date===null){
                fd.append('instalment_check_date','');
            }else {
                fd.append('instalment_check_date', Moment(JDate.toGregorian(row.instalment_check_date.year, row.instalment_check_date.month, row.instalment_check_date.day)).format('YYYY-MM-DD h:mm:ss') );
            }
            fd.append('request_id', request_id );

            xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
            xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
            xhttp.send(fd);
        }else {
            this.setState({ snackstr: "لطفا تاریخ یا شماره چک را وارد نمایید",showSnack:true,snackMode:"error" });
        }
    }


    handleChangeAmountAllCheck = (event) => {
        this.setState({ amountAllCheck:event });
    }

    handleChangeAmountState6 = (event) => {
        this.setState({ amountState6:event });
    }
    handleChangeOtpCode = (event) => {
        this.setState({ otpCode:event });
    }

    setSelectedDayStart=(event)=>{
        this.setState({ selectedDayStart: event })
    }

    handleCompany= (selectedComoany) => {
        this.setState({ selectedComoany:selectedComoany },()=>{
            this.getoptionAgent();

        });
    }
    setSelectedDayStartIns=(event)=>{
        const {selectedDayEndIns,selectedDayStartIns} = this.state;
        if(selectedDayEndIns===""||(selectedDayEndIns.day===selectedDayStartIns.day&&selectedDayEndIns.month===selectedDayStartIns.month)){
            this.setState({ selectedDayEndIns: {year:event.year+1,month:event.month,day:event.day} })
        }
        this.setState({selectedDayStartIns:event})
    }

    setSelectedDayCheck=(event)=>{
        console.log(event)
        this.setState({selectedDayCheck:event})
    }

    setSelectedDayEndIns=(event)=>{
        this.setState({ selectedDayEndIns: event })
    }


    clearDeyStart=(event)=>{
        this.setState({ selectedDayStart:""  })
    }

    clearDeyStartIns=(event)=>{
        this.setState({ selectedDayStartIns:""  })
    }

clearDeyCheck=(event)=>{
        this.setState({ selectedDayCheck:""  })
    }

    clearDeyEndIns=(event)=>{
        this.setState({ selectedDayEndIns:""  })
    }


    onSelectfileRequest=(event)=> {
        console.log(event.target.files[0]);
        this.setState({
            fileRequestReady: event.target.files[0],
        });
    }

    onSelectPicRequest=(picture)=> {
        this.setState({
            picturesRequestReady: picture[0],
        });
    }

    handleState= (selectedState) => {
        this.setState({ selectedState:selectedState,selectedCity:null },()=>{
            this.getoptionCityID();
        });
    }

    handleCity= (selectedCity) => {
        this.setState({ selectedCity:selectedCity });
    }

    handleCovarageCalculate= (selectedClearingMode) => {
        this.setState({ selectedClearingMode:selectedClearingMode,
        })
    }
    handleEmployee= (selectedEmployee) => {
        this.setState({ selectedEmployee:selectedEmployee,
        })
    }
    handleAgent= (selectedAgent) => {
        this.setState({ selectedAgent:selectedAgent });
    }
    handleState2= (selectedState2) => {
        this.setState({ selectedState2:selectedState2,selectedCity2:{ value: '0', label: 'همه شهرها'} },()=>{
            this.getoptionCityID2();
            this.getoptionAgent();

        });
    }

    handleCity2= (selectedCity2) => {
        this.setState({ selectedCity2:selectedCity2 },()=>{
            this.getoptionAgent();

        });
    }

    handleModeDelivery= (selectedModeDelivery) => {
        this.setState({ selectedModeDelivery:selectedModeDelivery });
    }


    changeSatus11=(image_code)=>{
        const {selectedState,selectedCity,selectedModeDelivery,resource} =  this.state;
        const {requestState} = this.props;

        this.props.props.dispatch({
            type : 'WAITSHOW',
        })
        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);

                if(arr.result==='ok'){
                    self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"success"  ,
                        showPaper:[true,false,false,false,false,false,false],
                        showChangeStatus:[false,false,false,false,false,false,false,false,false,false,false,false,false]
                    });
                    self.props.props.dispatch({
                        type : 'STATEREQUEST',
                        state : arr.data[0]
                    })
                }else if(arr.result==='error'){
                    self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                }
                self.props.props.dispatch({
                    type : 'WITEHIDE',
                })
            }
        }
        var fd = new FormData();
        fd.append('command', 'requestdelivered11' );
        fd.append('request_id', requestState['request_id'] );
        fd.append('request_delivered_dsc',resource );
        fd.append('request_delivered_mode_id', selectedModeDelivery.value );
        fd.append('request_delivered_receipt_image_code', image_code );
        fd.append('request_delivered_state_id',selectedState.value );
        fd.append('request_delivered_city_id', selectedCity.value );

        xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
        xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
        xhttp.send(fd);


    }


    uploadPicDelivery= (event) => {
        const {picturesRequestReady,selectedCity,selectedModeDelivery} =  this.state;
        const {requestState} = this.props;
        if((picturesRequestReady&&picturesRequestReady!==""&&picturesRequestReady!==null)&&selectedCity!==null&&selectedCity!==""&&selectedModeDelivery!==null&&selectedModeDelivery!==""){

            this.setState({
                loading: true,
                percent:0,
            });

            var self=this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText);

                    if(arr.result==='ok'){
                        self.changeSatus11(arr.data['image_code'])

                    }else if(arr.result==="error"){

                    }
                };
            }
            var fd = new FormData();
            fd.append("command","uptoabr");
            fd.append("image",picturesRequestReady);
            fd.append("image_name",'رسید تحویل');
            fd.append("image_desc","رسید تحویل سفارش شماره"+requestState['request_id']);
            fd.append("name",'');
            xhttp.upload.addEventListener("progress", function(evt){
                if (evt.lengthComputable) {
                    var percentComplete = evt.loaded / evt.total;
                    self.setState({
                        percent:percentComplete*100
                    })
                }
            }, false);
            xhttp.open("POST","https://api.rahnamayefarda.ir/api/image");
            xhttp.send(fd);

        }else {
            this.setState({ snackstr: "لطفا مشخصات و عکس رسید تحویل را وارد نمایید.",showSnack:true,snackMode:"error" });
        }

    }

    uploadFileRequest= (event) => {
        const {requestState} = this.props;
        const {fileRequestReady,detailFile} =  this.state;
        if((fileRequestReady&&fileRequestReady!==""&&fileRequestReady!==null)&&detailFile!==""){
            this.setState({
                loading: true,
                percent:0,
            });

            var self=this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText);
                    if(arr.result==='ok'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"success" ,
                            picturesRequestReady:"",namePic:"",detailPic:"",loading: false,
                            percent:0,
                            detailFile:'',
                            fileRequestReady:''
                        });
                        self.props.props.dispatch({
                            type : 'STATEREQUEST',
                            state : arr.data[0],
                        })

                    }else if(arr.result==='error'){
                        self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                    }


                };
            }
            var fd = new FormData();
            fd.append("command","add_filerequest");
            fd.append("filerequest",fileRequestReady);
            fd.append("request_file_desc",detailFile);
            fd.append("request_file_request_id",requestState['request_id']);



            fd.append("name",'');
            xhttp.upload.addEventListener("progress", function(evt){
                if (evt.lengthComputable) {
                    var percentComplete = evt.loaded / evt.total;
                    //Do something with upload progress
                    self.setState({
                        percent:percentComplete*100
                    })
                }
            }, false);
            xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
            xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
            xhttp.send(fd);

        }else {
            this.setState({ snackstr: "لطفا مشخصات فایل های بیمه نامه صادر شده را وارد نمایید",showSnack:true,snackMode:"error" });
        }

    }

    uploadPicRequest= (event) => {
        const {picturesRequestReady,namePic,detailPic} =  this.state;
        if((picturesRequestReady&&picturesRequestReady!==""&&picturesRequestReady!==null)&&namePic!==""&&detailPic!==""){
            this.setState({
                loading: true,
                percent:0,
            });

            var self=this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText);

                    if(arr.result==='ok'){
                        self.savePicInRequest(arr.data['image_code'])

                    }else if(arr.result==="error"){

                    }
                };
            }
            var fd = new FormData();
            fd.append("command","uptoabr");
            fd.append("image",picturesRequestReady);
            fd.append("image_name",namePic);
            fd.append("image_desc",detailPic);
            fd.append("name",'');
            xhttp.upload.addEventListener("progress", function(evt){
                if (evt.lengthComputable) {
                    var percentComplete = evt.loaded / evt.total;
                    //Do something with upload progress
                    self.setState({
                        percent:percentComplete*100
                    })
                }
            }, false);
            xhttp.open("POST","https://api.rahnamayefarda.ir/api/image");
            xhttp.send(fd);

        }else {
            this.setState({ snackstr: "لطفا مشخصات عکس بیمه نامه صادر شده را وارد نمایید",showSnack:true,snackMode:"error" });
        }

    }

    savePicInRequest=(image_code)=>{
        const {requestState} = this.props;
        this.props.props.dispatch({
            type : 'WAITSHOW',
        })
        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);

                if(arr.result==='ok'){
                    self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"success" ,
                        picturesRequestReady:"",namePic:"",detailPic:"",loading: false,
                        percent:0,
                    });
                    self.props.props.dispatch({
                        type : 'STATEREQUEST',
                        state : arr.data[0],
                    })

                }else if(arr.result==='error'){
                    self.setState({ snackstr: arr.desc,showSnack:true,snackMode:"error" });
                }
                self.props.props.dispatch({
                    type : 'WITEHIDE',
                })
            }
        }
        var fd = new FormData();
        fd.append('command', 'requestreadyimgsave' );
        fd.append('request_id', requestState['request_id'] );
        fd.append('requst_ready_image_code', image_code );

        xhttp.open("POST","https://api.rahnamayefarda.ir/api/employeerequestreport");
        xhttp.setRequestHeader("Authorization", this.cookies.get('employee_token_str'));
        xhttp.send(fd);

    }


    renderCustomInputStart = ({ ref }) => (
        <OutlinedInput
            readOnly
            ref={ref} // necessary
            placeholder="تاریخ یادآوری"
            style={{
                fontSize:'13px',
                direction:'ltr'
            }}
            value={this.state.selectedDayStart.year ? (this.state.selectedDayStart.year+'/'+ this.state.selectedDayStart.month+'/'+this.state.selectedDayStart.day):''}
            className="my-custom-input-class" // a styling class

            endAdornment={
                <InputAdornment position="end">
                    <IconButton
                        onClick={this.clearDeyStart}
                    >
                        <HighlightOffIcon/>
                    </IconButton>
                </InputAdornment>
            }
        />
    )


    renderCustomInputCheck = ({ ref }) => (
        <OutlinedInput
            readOnly
            ref={ref} // necessary
            placeholder="تاریخ شروع تعهد ها "
            style={{
                fontSize:'13px',
                direction:'ltr'
            }}
            value={this.state.selectedDayCheck.year ? (this.state.selectedDayCheck.year+'/'+ this.state.selectedDayCheck.month+'/'+this.state.selectedDayCheck.day):''}
            className="my-custom-input-class" // a styling class

            endAdornment={
                <InputAdornment position="end">
                    <IconButton
                        onClick={this.clearDeyCheck}
                    >
                        <HighlightOffIcon/>
                    </IconButton>
                </InputAdornment>
            }
        />
    )


    renderCustomInputStartIns = ({ ref }) => (
        <OutlinedInput
            readOnly
            ref={ref} // necessary
            placeholder="تاریخ شروع بیمه نامه"
            style={{
                fontSize:'13px',
                direction:'ltr'
            }}
            value={this.state.selectedDayStartIns.year ? (this.state.selectedDayStartIns.year+'/'+ this.state.selectedDayStartIns.month+'/'+this.state.selectedDayStartIns.day):''}
            className="my-custom-input-class" // a styling class

            endAdornment={
                <InputAdornment position="end">
                    <IconButton
                        onClick={this.clearDeyStartIns}
                    >
                        <HighlightOffIcon/>
                    </IconButton>
                </InputAdornment>
            }
        />
    )

    renderCustomInputEndIns = ({ ref }) => (
        <OutlinedInput
            readOnly
            ref={ref} // necessary
            placeholder="تاریخ شروع بیمه نامه"
            style={{
                fontSize:'13px',
                direction:'ltr'
            }}
            value={this.state.selectedDayEndIns.year ? (this.state.selectedDayEndIns.year+'/'+ this.state.selectedDayEndIns.month+'/'+this.state.selectedDayEndIns.day):''}
            className="my-custom-input-class" // a styling class

            endAdornment={
                <InputAdornment position="end">
                    <IconButton
                        onClick={this.clearDeyEndIns}
                    >
                        <HighlightOffIcon/>
                    </IconButton>
                </InputAdornment>
            }
        />
    )

    render() {
        const {requestState} = this.props;
        const { classes } = this.props;
        const {changeDetailReadyState,optionInstalmentMode,selectedEmployee,selectedClearingMode,optionComoany,selectedComoany,optionCity,selectedCity,optionEmployee,optionClearingMode,optionAgent,selectedAgent,optionCity2,selectedCity2,optionModeDelivery,selectedModeDelivery,optionState,selectedState,optionState2,selectedState2,percent,loading,detailPic,detailFile,namePic,requst_ready_num_ins,requst_ready_code_rayane,requst_ready_code_penalty,requst_ready_code_yekta,requst_ready_code_insurer,requst_ready_name_insurer,requst_ready_end_price,selectedDayStart,selectedDayStartIns,selectedDayCheck,selectedDayEndIns,requst_suspend_desc,resource,amountAllCheck,amountState6,otpCode,showChangeStatus,snackMode,snackstr,showSnack,menuIcon,showPaper,urlToHugeImageFile,descImageFile,urlToLargeImageFile } = this.state;
        var request_addressofinsured=null;
        var request_adderss=null;
        var user_pey_detail=null;
        var user_pey_detail2=null;
        var request_stats=null;
        var request_image=null;
        var request_ready=null;
        var request_delivered=null;
        var request_ready_image_tb=null;
        var request_ready_file_tb=null;
        var visit_image=null;

        if(requestState['request_addressofinsured']){
            request_addressofinsured=requestState['request_addressofinsured'][0];
        }

        if(requestState['request_ready']){
            request_ready=requestState['request_ready'][0];
            if(request_ready){
                if(request_ready['request_ready_image_tb']){
                    request_ready_image_tb=request_ready['request_ready_image_tb'];
                }
                if(request_ready['request_ready_file_tb']){
                    request_ready_file_tb=request_ready['request_ready_file_tb'];
                }

            }
        }

        if(requestState['request_delivered']){
            request_delivered=requestState['request_delivered'][0];
        }

        if(requestState['visit_image']){
            visit_image=requestState['visit_image'];
        }

        if(requestState['request_adderss']){
            request_adderss=requestState['request_adderss'][0];
        }
        if(requestState['user_pey_detail']){
            user_pey_detail=requestState['user_pey_detail'];
        }
        if(requestState['user_pey_detail2']){
            user_pey_detail2=requestState['user_pey_detail2'];
        }

        if(requestState['request_stats']){
            request_stats=requestState['request_stats'];
        }
        if(requestState['request_image']){
            request_image=requestState['request_image'];
        }
        var stateId=requestState['request_last_state_id'];
        return (
            <div className={classes.paperrtl} dir="rtl">


                {(requestState['request_id'])?
                    <Container component="main" maxWidth="lg">
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                            </Grid>
                            <Grid item xs={12}>

                                <Paper elevation={4} className={classes.root}>
                                    <Container component="main" maxWidth="lg">

                                        <Grid container spacing={3}>

                                            <Grid item xs={4}>
                                                <div style={{width:'100%',textAlign:'right'}}>
                                                    <Typography align='center' variant="h7"  >
                                                        {'شمارdddddه درخواست: '+requestState['request_id']}
                                                    </Typography>
                                                </div>
                                            </Grid>

                                            <Grid item xs={8} sm={4}>
                                                <div style={{width:'100%',textAlign:'center'}}>
                                                    <Typography align='center' variant="h7"  >
                                                        {'رشته بیمه : '+requestState['request_fieldinsurance_fa']}
                                                        <img alt="" style={{height: "30px",width: "atuo"}} src={requestState['fieldinsurance_logo_url']} />

                                                    </Typography>
                                                </div>
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <div style={{width:'100%',textAlign:'center'}}>
                                                    <Typography align='center' variant="h7"  >
                                                        {'شرکت  : '+requestState['company_name']}
                                                        <img alt="" style={{height: "30px",width: "atuo"}} src={requestState['company_logo_url']} />

                                                    </Typography>
                                                </div>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Divider/>
                                            </Grid>

                                            <Grid item xs={6}>
                                                <div style={{width:'100%',textAlign:'right'}}>
                                                    <Typography align='center' variant="h7"  >
                                                        {'آخرین وضعیت: '+requestState['request_last_state_name']}
                                                    </Typography>
                                                </div>
                                            </Grid>

                                            <Grid item xs={6}>
                                                <div style={{width:'100%',textAlign:'right'}}>
                                                    <Typography align='center' variant="h7"  >
                                                        {'تاریخ آخرین وضعیت: '} {
                                                        new JDate(new Date(parseInt(Moment(requestState['staterequest_last_timestamp'], 'YYYY-M-D HH:mm:ss').format('x')))).format('YYYY/MM/DD ')+"ساعت "+
                                                        Moment(requestState['staterequest_last_timestamp'], 'YYYY-M-D HH:mm:ss').format('HH:mm')
                                                    }

                                                    </Typography>
                                                </div>
                                            </Grid>


                                            <Grid item xs={6}>
                                                <div style={{width:'100%',textAlign:'right'}}>
                                                    <Typography align='center' variant="h7"  >
                                                        {'مشخصات کاربر: '+requestState['user_name']+' '+requestState['user_family']+' -  شماره همراه : '+requestState['user_mobile']}
                                                    </Typography>
                                                </div>
                                            </Grid>

                                            <Grid item xs={6}>
                                                <div style={{width:'100%',textAlign:'right'}}>
                                                    <Typography align='center' variant="h7"  >

                                                        {(requestState['user_pey_amount']===null||requestState['user_pey_amount']==='')?
                                                            'مبلغ پرداخت شده : 0 ریال'
                                                            :
                                                            'مبلغ پرداخت شده :  '
                                                        }
                                                        {(requestState['user_pey_amount']===null||requestState['user_pey_amount']==='')?
                                                            null
                                                            :
                                                            <NumberFormat displayType={'text'} value={requestState['user_pey_amount']} thousandSeparator={true} prefix={' ریال'} />

                                                        }
                                                    </Typography>
                                                </div>
                                            </Grid>

                                            <Grid item xs={6}>
                                                <div style={{width:'100%',textAlign:'right'}}>
                                                    <Typography align='center' variant="h7"  >
                                                        {'مشخصات نماینده: '+requestState['agent_name']+' '+requestState['agent_family']+' -  شماره همراه : '+requestState['agent_mobile']+' - کد : '+requestState['agent_code']}
                                                    </Typography>
                                                </div>
                                            </Grid>

                                            <Grid item xs={6}>
                                                <div style={{width:'100%',textAlign:'right'}}>
                                                    <Typography align='center' variant="h7"  >
                                                        {'استان : '+requestState['agent_state_name']+'   - شهرستان:  '+requestState['agent_city_name']}
                                                    </Typography>
                                                </div>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Divider/>
                                            </Grid>

                                            <Grid item xs={(stateId==='11')?12:9}>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12}>

                                                        <div style={{width:'100%',textAlign:'right'}}>

                                                            <Typography align='center' variant="h7"  >
                                                                {'جزئیات درخواست: '+requestState['request_description']}
                                                            </Typography>

                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={12}>

                                                        <div style={{width:'100%',textAlign:'right'}}>

                                                            {requestState["organ_request_confirm_admin_id"] === "0" ||
                                                            requestState["organ_request_confirm_admin_id"] === 0 ? (
                                                                <Fab variant="extended">
                                                                    <VoiceOverOffIcon />
                                                                    {" تایید نشده"}
                                                                </Fab>
                                                            ) : (
                                                                <Fab
                                                                    variant="extended"
                                                                    style={{ background: "#44b700" }}
                                                                >
                                                                    <RecordVoiceOverIcon />
                                                                    {"تایید شده"+
                                                                        new JDate(
                                                                        new Date(
                                                                        parseInt(
                                                                        Moment(
                                                                        requestState["organ_request_confirm_admin_date"],
                                                                        "YYYY-M-D HH:mm:ss"
                                                                        ).format("x")
                                                                        )
                                                                        )
                                                                        ).format("YYYY/MM/DD")
                                                                    }
                                                                </Fab>
                                                            )}

                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <div>
                                                            {(stateId==='10'||stateId==='11') ? <Button  variant="outlined" color="primary" onClick={this.showInsertImage}>اضافه کردن عکس های بیمه نامه </Button>:null}
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <div>
                                                            {(stateId==='10'||stateId==='11') ? <Button  variant="outlined" color="primary" onClick={this.changeDetailReady}>تغییر مشخصات صدور </Button>:null}
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <div>
                                                            {(stateId==='11') ? <Button  variant="outlined" color="primary" onClick={this.showChangeStatus11}>ثبت مشخصات و رسید تحویل</Button>:null}
                                                        </div>
                                                    </Grid>
                                                </Grid>

                                            </Grid>

                                            <Grid item xs={3}>

                                                <div>
                                                    <Button  variant="outlined" color="primary" onClick={this.handleClick}>
                                                        تغییر وضعیت
                                                    </Button>
                                                    <Menu
                                                        id="simple-menu"
                                                        anchorEl={this.state.anchorEl}
                                                        keepMounted
                                                        open={Boolean(this.state.anchorEl)}
                                                        onClose={this.handleClose}
                                                    >
                                                        {(stateId==='2'||stateId==='8'||stateId==='9'||stateId==='10'||stateId==='11') ?  <MenuItem onClick={this.showChangeStatus3}>{arrStaus[3]}</MenuItem>:null}
                                                        {(stateId==='3'||stateId==='7'||stateId==='8') ? <MenuItem onClick={this.showChangeStatus4}>{arrStaus[4]}</MenuItem>:null}
                                                        {(stateId==='3'||stateId==='7'||stateId==='8') ? <MenuItem onClick={this.showChangeStatus5}>{arrStaus[5]}</MenuItem>:null}
                                                        {(stateId==='3'||stateId==='7') ? <MenuItem onClick={this.showChangeStatus6}>{arrStaus[6]}</MenuItem>:null}
                                                        {(stateId==='3'||stateId==='8') ? <MenuItem onClick={this.showChangeStatus7}>{arrStaus[7]}</MenuItem>:null}
                                                        {(stateId==='3'||stateId==='7') ? <MenuItem onClick={this.showChangeStatus8}>{arrStaus[8]}</MenuItem>:null}
                                                        {(stateId==='3'||stateId==='8'||stateId==='7') ? <MenuItem onClick={() =>{this.changeSatus9(requestState['request_id'],requestState['agent_id']);}}>{arrStaus[9]}</MenuItem>:null}
                                                        {(stateId==='9') ? <MenuItem onClick={this.showChangeStatus10}>{arrStaus[10]}</MenuItem>:null}
                                                        {(stateId==='10') ? <MenuItem onClick={this.showChangeStatus11}>{arrStaus[11]}</MenuItem>:null}
                                                        {(stateId==='6') ? <MenuItem onClick={() =>{this.changeSatusfrom6(requestState['request_id'],requestState['agent_id']);}}>حذف کسری واریزی</MenuItem>:null}
                                                        {(stateId==='3'||stateId==='7') ? <MenuItem onClick={() =>{this.changeSatusfrom16(requestState['request_id'],requestState['agent_id']);}}> نیاز به بازدید</MenuItem>:null}
                                                        {(stateId==='16') ? <MenuItem onClick={() =>{this.changeDeleteSatusfrom16(requestState['request_id'],requestState['agent_id']);}}>حذف نیاز به بازدید</MenuItem>:null}
                                                        {(stateId==='3'||stateId==='7') ? <MenuItem onClick={this.showChangeStatus12}>{arrStaus[12]}</MenuItem>:null}

                                                    </Menu>
                                                </div>

                                            </Grid>

                                            <Grid item xs={12}>

                                                <div style={{width:'100%',textAlign:'center', overflow: 'auto'}}>

                                                    <BottomNavigation
                                                        value={menuIcon}
                                                        onChange={(event, newValue) => {
                                                            this.setValueMenuIcon(event, newValue);
                                                        }}
                                                        showLabels
                                                        className={classes.root}
                                                    >
                                                        <BottomNavigationAction label="آدرس" icon={<HomeWorkIcon/>} />
                                                        <BottomNavigationAction label="مالی" icon={<AttachMoneyIcon />} />
                                                        <BottomNavigationAction label="وضعیت ها" icon={<HistoryIcon />} />
                                                        <BottomNavigationAction label="عکس ها" icon={<PhotoLibraryIcon />} />
                                                        <BottomNavigationAction label="جزئیات صدور" icon={<DetailsIcon />} />
                                                        <BottomNavigationAction label=""  />
                                                        <BottomNavigationAction label="" />
                                                        <BottomNavigationAction label="بازدید" icon={<PhotoLibraryIcon />} />
                                                    </BottomNavigation>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Container>
                                </Paper>
                            </Grid>

                            <Grid item xs={12}>
                                <Collapse in={showPaper[5]}>
                                    <Paper elevation={4} style={{marginTop:"15px"}}>
                                        <Container component="main" maxWidth="lg">

                                            <Collapse in={showChangeStatus[3]}>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h6" >
                                                            {arrStaus[3]}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <FloatingLabelInput placeholder="" value={resource} handleInputt={this.handleChangeResorce}  />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <Button   variant="outlined" color="primary" onClick={() => {this.changeSatus3(requestState['request_id'],requestState['agent_id'])}}>
                                                            تغییر وضعیت به درحال بررسی
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Collapse>


                                            <Collapse in={showChangeStatus[4]}>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h6" >
                                                            {arrStaus[4]}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <FloatingLabelInput placeholder="علت بازگشت به کاربر" value={resource} handleInputt={this.handleChangeResorce}  />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <Button   variant="outlined" color="primary" onClick={() => {this.cancelRequest(requestState['request_id'],requestState['agent_id'])}}>
                                                            تغییر وضعیت به بازگشت به کاربر
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Collapse>


                                            <Collapse in={showChangeStatus[5]}>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h6" >
                                                            {arrStaus[5]}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4}>
                                                        <div >
                                                            <label  className="on" >شرکت بیمه</label>
                                                            <Select  isSearchable={true}
                                                                     className="adapter-txtsize"
                                                                     placeholder ={'شرکت بیمه'}
                                                                     value={selectedComoany}
                                                                     onChange={this.handleCompany}
                                                                     options={optionComoany} />
                                                        </div>
                                                    </Grid>

                                                    <Grid item xs={12} sm={4}>
                                                        <div >
                                                            <label  className="on" >استان</label>
                                                            <Select  isSearchable={true}
                                                                     className="adapter-txtsize"
                                                                     placeholder ={'استان'}
                                                                     value={selectedState2}
                                                                     onChange={this.handleState2}
                                                                     options={optionState2} />
                                                        </div>
                                                    </Grid>

                                                    <Grid item xs={12} sm={4}>
                                                        <div >
                                                            <label  className="on" >شهر</label>
                                                            <Select  isSearchable={true}
                                                                     className="adapter-txtsize"
                                                                     placeholder ={'شهر'}
                                                                     value={selectedCity2}
                                                                     onChange={this.handleCity2}
                                                                     options={optionCity2} />
                                                        </div>
                                                    </Grid>

                                                    <Grid item xs={8} sm={4}>
                                                        <div >
                                                            <label  className="on" >نماینده</label>
                                                            <Select  isSearchable={true}
                                                                     className="adapter-txtsize"
                                                                     placeholder ={'نماینده'}
                                                                     value={selectedAgent}
                                                                     onChange={this.handleAgent}
                                                                     options={optionAgent} />
                                                        </div>
                                                    </Grid>
                                                    {(selectedAgent!=='')?
                                                        <Grid item xs={4} sm={2}>
                                                            {(selectedAgent.agent_status==='1'||selectedAgent.agent_status===1)?
                                                                <Fab variant="extended" style={{background:"#44b700"}} >
                                                                    <RecordVoiceOverIcon />
                                                                    { 'آنلاین'}
                                                                </Fab>

                                                                :
                                                                <Fab variant="extended" >
                                                                    <VoiceOverOffIcon />
                                                                    {'آفلاین '}
                                                                </Fab>
                                                            }
                                                        </Grid>
                                                        :null}

                                                    <Grid item xs={12}>
                                                        <FloatingLabelInput placeholder="علت بازگشت به نماینده دیگر" value={resource} handleInputt={this.handleChangeResorce}  />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <Button   variant="outlined" color="primary" onClick={() => {this.changeSatus5(requestState['request_id'],requestState['agent_id'])}}>
                                                            بازگشت به نماینده دیگر
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Collapse>


                                            <Collapse in={showChangeStatus[6]}>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h6" >
                                                            {arrStaus[6]}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <FloatingLabelInput  type="currency" placeholder="مبلغ کسری واریزی" value={amountState6} handleInputt={this.handleChangeAmountState6}  />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <FloatingLabelInput placeholder="علت کسری واریزی " value={resource} handleInputt={this.handleChangeResorce}  />
                                                    </Grid>

                                                    <Grid item xs={12} sm={6}>
                                                        <Button   variant="outlined" color="primary" onClick={() => {this.changeSatus6(requestState['request_id'],requestState['agent_id'])}}>
                                                            تغییر وضعیت به کسری واریزی
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Collapse>




                                            <Collapse in={showChangeStatus[7]}>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h6" >
                                                            {arrStaus[7]}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <Typography variant="h7" >{"تاریخ یادآوری  "}
                                                            <Calendar
                                                                renderInput={this.renderCustomInputStart} // render a custom input
                                                                value={selectedDayStart}
                                                                onChange={this.setSelectedDayStart}
                                                                locale="fa"
                                                                shouldHighlightWeekends
                                                            /></Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <FloatingLabelInput placeholder="علت تعلیق برای تاریخ صدور" value={resource} handleInputt={this.handleChangeResorce}  />
                                                    </Grid>

                                                    <Grid item xs={12} sm={6}>
                                                        <Button   variant="outlined" color="primary" onClick={() => {this.changeSatus7(requestState['request_id'],requestState['agent_id'])}}>
                                                            تغییر وضعیت به معلق برای صدور
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Collapse>


                                            <Collapse in={showChangeStatus[8]}>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h6" >
                                                            {arrStaus[8]}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <FloatingLabelInput placeholder="علت مشکل در مدارک" value={resource} handleInputt={this.handleChangeResorce}  />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <Button   variant="outlined" color="primary" onClick={() => {this.changeSatus8(requestState['request_id'],requestState['agent_id'])}}>
                                                            ثبت مشکل در مدارک و عکس ها
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Collapse>


                                            <Collapse in={showChangeStatus[10]}>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h6" >
                                                            {(changeDetailReadyState)?'تغییر مشخصات صدور':arrStaus[10]}
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <Typography variant="h7" >{"تاریخ شروع بیمه نامه"}
                                                            <Calendar
                                                                renderInput={this.renderCustomInputStartIns} // render a custom input
                                                                value={selectedDayStartIns}
                                                                onChange={this.setSelectedDayStartIns}
                                                                locale="fa"
                                                                shouldHighlightWeekends
                                                            /></Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <Typography variant="h7" >{"تاریخ پایان بیمه نامه"}
                                                            <Calendar
                                                                renderInput={this.renderCustomInputEndIns} // render a custom input
                                                                value={selectedDayEndIns}
                                                                onChange={this.setSelectedDayEndIns}
                                                                locale="fa"
                                                                shouldHighlightWeekends
                                                            /></Typography>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <FloatingLabelInput placeholder="َشماره بیمه نامه" value={requst_ready_num_ins} handleInputt={this.handleInsuranceNum}  />
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <FloatingLabelInput placeholder="کد یکتا بیمه نامه" value={requst_ready_code_yekta} handleInputt={this.handleInsuranceYekta}  />
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <FloatingLabelInput placeholder="کد رایانه بیمه نامه" value={requst_ready_code_rayane} handleInputt={this.handleInsuranceRayane}  />
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <FloatingLabelInput type={'number'} placeholder="کد ملی بیمه گذار" value={requst_ready_code_insurer} handleInputt={this.handleInsuranceCodeInsurer}  />
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <FloatingLabelInput placeholder="نام بیمه گذار" value={requst_ready_name_insurer} handleInputt={this.handleInsuranceNameInsurer}  />
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <FloatingLabelInput type={'currency'} placeholder="قیمت  نهایی" value={requst_ready_end_price} handleInputt={this.handleInsurancePrice}  />
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <FloatingLabelInput type={'currency'} placeholder="هر مبلغی که شامل کارمزد نمیشود" value={requst_ready_code_penalty} handleInputt={this.handleInsurancePenalty}  />
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <div>
                                                            <label  className="on" > نحوه تسویه</label>
                                                            <Select  isSearchable={true}
                                                                     className="adapter-txtsize"
                                                                     placeholder ={'نحوه تسویه'}
                                                                     value={selectedClearingMode}
                                                                     onChange={this.handleCovarageCalculate}
                                                                     options={optionClearingMode} />
                                                        </div>
                                                    </Grid>
                                                    {(changeDetailReadyState)?
                                                        <Grid item xs={6}>
                                                            <div>
                                                                <label  className="on" > کارمند</label>
                                                                <Select  isSearchable={true}
                                                                         className="adapter-txtsize"
                                                                         placeholder ={'نحوه تسویه'}
                                                                         value={selectedEmployee}
                                                                         onChange={this.handleEmployee}
                                                                         options={optionEmployee} />
                                                            </div>
                                                        </Grid>
                                                        :""}
                                                    <Grid item xs={12}>
                                                        <FloatingLabelInput placeholder="توضیحات بیمه نامه" value={requst_suspend_desc} handleInputt={this.handleRequstSuspendDesc}  />
                                                    </Grid>

                                                    <Grid item xs={12} sm={6}>
                                                        {(changeDetailReadyState)?
                                                            <Button   variant="outlined" color="primary" onClick={() => {this.changeSatusReady(requestState['request_id'],requestState['agent_id'])}}>
                                                                تغییر مشخصات صدور
                                                            </Button>
                                                            :
                                                            <Button   variant="outlined" color="primary" onClick={() => {this.changeSatus10(requestState['request_id'],requestState['agent_id'])}}>
                                                                ثبت وضعیت صادر شده
                                                            </Button>
                                                        }


                                                    </Grid>
                                                </Grid>
                                            </Collapse>


                                            <Collapse in={showChangeStatus[11]}>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h6" >
                                                            {arrStaus[11]}
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={4}>
                                                        <div >
                                                            <label  className="on" >نوع ارسال</label>
                                                            <Select  isSearchable={true}
                                                                     className="adapter-txtsize"
                                                                     placeholder ={'نوع ارسال'}
                                                                     value={selectedModeDelivery}
                                                                     onChange={this.handleModeDelivery}
                                                                     options={optionModeDelivery} />
                                                        </div>
                                                    </Grid>


                                                    <Grid item xs={12} sm={4}>
                                                        <div >
                                                            <label  className="on" >استان</label>
                                                            <Select  isSearchable={true}
                                                                     className="adapter-txtsize"
                                                                     placeholder ={'استان'}
                                                                     value={selectedState}
                                                                     onChange={this.handleState}
                                                                     options={optionState} />
                                                        </div>
                                                    </Grid>

                                                    <Grid item xs={12} sm={4}>
                                                        <div >
                                                            <label  className="on" >شهر</label>
                                                            <Select  isSearchable={true}
                                                                     className="adapter-txtsize"
                                                                     placeholder ={'شهر'}
                                                                     value={selectedCity}
                                                                     onChange={this.handleCity}
                                                                     options={optionCity} />
                                                        </div>
                                                    </Grid>

                                                    <Grid item xs={12} sm={8}>
                                                        <FloatingLabelInput placeholder="توضیحات تحویل " value={resource} handleInputt={this.handleChangeResorce}  />
                                                    </Grid>

                                                    <Grid item xs={12} sm={4}>

                                                        <ImageUploader
                                                            withIcon={true}
                                                            buttonText='عکس را انتخاب نمایید'
                                                            onChange={this.onSelectPicRequest}
                                                            withPreview='true'
                                                            singleImage='true'
                                                            imgExtension={['.jpg','.jpeg', '.gif', '.png', '.gif']}
                                                            maxFileSize={5242880}
                                                        />
                                                    </Grid>


                                                    <Grid item xs={12}>
                                                        {loading && <LinearProgress variant="determinate" value={percent} />}
                                                    </Grid>

                                                    <Grid item xs={12} sm={6}>
                                                        <Button   variant="outlined" color="primary" onClick={this.uploadPicDelivery}>
                                                            ثبت وضعیت تحویل شده به کاربر
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Collapse>


                                        </Container>
                                    </Paper>
                                </Collapse>

                                <Collapse in={(showPaper[6]||showChangeStatus[10])}>
                                    <Paper elevation={4} style={{marginTop:"15px"}}>
                                        <Container component="main" maxWidth="lg">

                                            <Grid container spacing={3}>
                                                <Grid item xs={12} sm={6}>

                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12}>

                                                            <ImageUploader
                                                                withIcon={true}
                                                                buttonText='عکس را انتخاب نمایید'
                                                                onChange={this.onSelectPicRequest}
                                                                withPreview='true'
                                                                singleImage='true'
                                                                imgExtension={['.jpg','.jpeg', '.gif', '.png', '.gif']}
                                                                maxFileSize={5242880}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12}>
                                                            <FloatingLabelInput placeholder="نام عکس" value={namePic} handleInputt={this.handleChangeNamePic}  />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <FloatingLabelInput placeholder="توضیحات عکس " value={detailPic} handleInputt={this.handleChangeDetailPic}  />
                                                        </Grid>

                                                        <Grid item xs={12}>
                                                            {loading && <LinearProgress variant="determinate" value={percent} />}
                                                        </Grid>


                                                        <Button  variant="outlined" color="primary" onClick={this.uploadPicRequest}>
                                                            ثبت تصویر بیمه نامه
                                                        </Button>
                                                        <Grid item xs={12}>

                                                        </Grid>

                                                    </Grid>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>

                                                    {(request_ready_image_tb)?

                                                        <TableContainer component={Paper}>
                                                            <Table className={classes.table} aria-label="simple table">
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell style={{ minWidth: 60 }} align="center">نام عکس</TableCell>
                                                                        <TableCell style={{ minWidth: 100 }} align="center">توضیحات</TableCell>
                                                                        <TableCell style={{ minWidth: 30 }} align="center">عکس </TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {request_ready_image_tb.map(row =>
                                                                    {
                                                                        return(
                                                                            <TableRow key={row.image_name}>
                                                                                <TableCell align="center"> {row.image_name}</TableCell>
                                                                                <TableCell align="center">{row.image_desc}</TableCell>

                                                                                <TableCell align="center">
                                                                                    <div style={{width:'100%',textAlign:'center'}}>
                                                                                        <Avatar  variant='rounded' alt="Remy Sharp" src={row.image_tumb_url}
                                                                                                 onClick={() => {
                                                                                                     this.setImageModel(row.image_tumb_url, row.image_url,row.image_name);
                                                                                                 }}
                                                                                        />
                                                                                    </div>
                                                                                </TableCell>

                                                                            </TableRow>
                                                                        )})}
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>

                                                        :null}
                                                </Grid>
                                            </Grid>



                                            <Divider/>
                                        </Container>
                                        <Container component="main" maxWidth="lg">

                                            <Grid container spacing={3}>
                                                <Grid item xs={12} sm={6}>

                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12}>
                                                            <input type="file" onChange={this.onSelectfileRequest}/>

                                                        </Grid>


                                                        <Grid item xs={12}>
                                                            <FloatingLabelInput placeholder="توضیحات فایل " value={detailFile} handleInputt={this.handleChangeDetailFile}  />
                                                        </Grid>



                                                        <Button  variant="outlined" color="primary" onClick={this.uploadFileRequest}>
                                                            ثبت فایل بیمه نامه
                                                        </Button>
                                                        <Grid item xs={12}>

                                                        </Grid>

                                                    </Grid>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>

                                                    {(request_ready_file_tb)?

                                                        <TableContainer component={Paper}>
                                                            <Table className={classes.table} aria-label="simple table">
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell style={{ minWidth: 100 }} align="center">توضیحات</TableCell>
                                                                        <TableCell style={{ minWidth: 30 }} align="center">لینک دانلود </TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {request_ready_file_tb.map(row =>
                                                                    {
                                                                        return(
                                                                            <TableRow key={row.request_file_desc}>
                                                                                <TableCell align="center"> {row.request_file_desc}</TableCell>

                                                                                <TableCell align="center">
                                                                                    <a href={row.request_file_url}>دانلود</a>
                                                                                </TableCell>

                                                                            </TableRow>
                                                                        )})}
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>

                                                        :null}
                                                </Grid>
                                            </Grid>




                                        </Container>

                                    </Paper>
                                </Collapse>



                                <Collapse in={showChangeStatus[12]}>
                                    <Paper elevation={4} style={{marginTop:"15px"}}>
                                        <Container component="main" maxWidth="lg">

                                            <Grid container spacing={3}>
                                                <Grid item xs={12}>
                                                    <Typography variant="h6" >
                                                        {arrStaus[12]}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <FloatingLabelInput type="currency" placeholder="مبلغ اضافه واریزی" value={amountState6} handleInputt={this.handleChangeAmountState6}  />
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <FloatingLabelInput placeholder="علت اضافه واریزی " value={resource} handleInputt={this.handleChangeResorce}  />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Button   variant="outlined" color="primary" onClick={() => {this.changeSatus12(requestState['request_id'],requestState['agent_id'],requestState['user_id'])}}>
                                                        اعمال اضافه واریزی
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Container>
                                    </Paper>
                                </Collapse>





                                <Collapse in={showPaper[0]}>
                                    <Paper elevation={4} style={{marginTop:"15px"}}>
                                        <Container component="main" maxWidth="lg">
                                            {(request_addressofinsured)?
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h6" > آدرس مورد بیمه</Typography>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Typography variant="h7" >{'شماره همراه: '}{request_addressofinsured['user_address_mobile']}</Typography>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Typography variant="h7" >{'تلفن: '}{request_addressofinsured['user_address_tell']}</Typography>
                                                    </Grid>


                                                    <Grid item xs={4}>
                                                        <Typography variant="h7" >{'استان: '}{request_addressofinsured['user_address_state']}</Typography>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <Typography variant="h7" >{'َشهر: '}{request_addressofinsured['user_address_city']}</Typography>
                                                    </Grid>
                                                    <Grid item xs={5}>
                                                        <Typography variant="h7" >{'کد پستی: '}{request_addressofinsured['user_address_code']}</Typography>
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <Typography variant="h7" >{'آدرس : '}{request_addressofinsured['user_address_str']}</Typography>
                                                    </Grid>

                                                </Grid>
                                                :null}

                                            <Grid item xs={12}>
                                                <Divider/>
                                            </Grid>

                                            {(request_adderss)?
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h6" > آدرس ارسال بیمه</Typography>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Typography variant="h7" >{'شماره همراه: '}{request_adderss['user_address_mobile']}</Typography>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Typography variant="h7" >{'تلفن: '}{request_adderss['user_address_tell']}</Typography>
                                                    </Grid>


                                                    <Grid item xs={4}>
                                                        <Typography variant="h7" >{'استان: '}{request_adderss['user_address_state']}</Typography>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <Typography variant="h7" >{'َشهر: '}{request_adderss['user_address_city']}</Typography>
                                                    </Grid>
                                                    <Grid item xs={5}>
                                                        <Typography variant="h7" >{'کد پستی: '}{request_adderss['user_address_code']}</Typography>
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <Typography variant="h7" >{'آدرس : '}{request_adderss['user_address_str']}</Typography>
                                                    </Grid>
                                                    <Divider/>
                                                </Grid>
                                                :null}



                                        </Container>
                                    </Paper>
                                </Collapse>

                                <Collapse in={showPaper[1]}>
                                    <Paper elevation={4} style={{marginTop:"15px"}}>
                                        <Container component="main" maxWidth="lg">
                                            <Grid container spacing={3}>
                                                <Grid item xs={12}>
                                                    <Typography align='center' variant="h6"  >

                                                        {(requestState['user_pey_amount']===null||requestState['user_pey_amount']==='')?
                                                            'مبلغ پرداخت شده : 0 ریال'
                                                            :
                                                            'مبلغ پرداخت شده :  '
                                                        }
                                                        {(requestState['user_pey_amount']===null||requestState['user_pey_amount']==='')?
                                                            null
                                                            :
                                                            <NumberFormat displayType={'text'} value={requestState['user_pey_amount']} thousandSeparator={true} prefix={' ریال'} />
                                                        }
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Divider/>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography align='center' variant="h6"  >

                                                        {(requestState['user_pey_cash']===null||requestState['user_pey_cash']==='')?
                                                            'مبلغ نقدی پرداخت شده : 0 ریال'
                                                            :
                                                            'مبلغ نقدی پرداخت شده :  '
                                                        }
                                                        {(requestState['user_pey_cash']===null||requestState['user_pey_cash']==='')?
                                                            null
                                                            :
                                                            <NumberFormat displayType={'text'} value={requestState['user_pey_cash']} thousandSeparator={true} prefix={' ریال'} />

                                                        }
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>

                                                    {(user_pey_detail2)?

                                                        <TableContainer component={Paper}>
                                                            <Table className={classes.table} aria-label="simple table">
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell align="center"> مبلغ پرداخت شده</TableCell>
                                                                        <TableCell align="center">توضیحات</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {user_pey_detail2.map(row => (
                                                                        <TableRow key={row.user_pey_amount}>
                                                                            <TableCell align="center">
                                                                                <NumberFormat displayType={'text'} value={row.user_pey_amount} thousandSeparator={true} prefix={' ریال'} />

                                                                            </TableCell>
                                                                            <TableCell align="center">{row.user_pey_desc}</TableCell>

                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>

                                                        :null}
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Divider/>
                                                </Grid>
                                                {(requestState['organ_id']===15||requestState['organ_id']==='15')?
                                                <Grid item xs={12}>
                                                        <Grid container spacing={3}>
                                                <Grid item xs={4} sm={4}>
                                                    <Typography align='center' variant="h6"  >

                                                        {(requestState['user_pey_amount']===null||requestState['user_pey_amount']==='')?
                                                            'اصلاح مبلغ پرداخت شده : 0 ریال'
                                                            :
                                                            ' اصلاح مبلغ پرداخت شده به :  '
                                                        }
                                                        {(requestState['user_pey_amount']===null||requestState['user_pey_amount']==='')?
                                                            null
                                                            :
                                                            <NumberFormat displayType={'text'} value={requestState['user_pey_amount']} thousandSeparator={true} prefix={' ریال'} />
                                                        }
                                                    </Typography>

                                                </Grid>
                                                <Grid item xs={2}sm={2} >
                                                    <Button   variant="outlined" color="primary"  onClick={(e) => {
                                                        this.changeRquestEtma(requestState['user_id'],parseInt(requestState['user_pey_amount']),requestState['request_id']);
                                                    }}
                                                    >
                                                       ارسال کد  اتما
                                                    </Button>

                                                </Grid>
                                                    <Grid item xs={4} sm={4}>
                                                        <FloatingLabelInput  type="number" placeholder="کد ارسالی به کاربر  " value={otpCode} handleInputt={this.handleChangeOtpCode}  />

                                                    </Grid>
                                                            <Grid item xs={2}sm={2} >
                                                                <Button   variant="outlined" color="primary"  onClick={(e) => {
                                                                    this.checkOtp(requestState['user_id'],parseInt(requestState['user_pey_amount']),requestState['request_id']);
                                                                }}
                                                                >بررسی کد</Button>

                                                            </Grid>
                                                            </Grid>
                                                </Grid>
                                                    :null}
                                                <Grid item xs={12}>
                                                    <Typography align='center' variant="h6"  >

                                                        {(requestState['user_pey_instalment']===null||requestState['user_pey_instalment']==='')?
                                                            'مبلغ اقساط پرداخت شده : 0 ریال'
                                                            :
                                                            'مبلغ اقساط پرداخت شده :  '
                                                        }
                                                        {(requestState['user_pey_instalment']===null||requestState['user_pey_instalment']==='')?
                                                            null
                                                            :
                                                            <NumberFormat displayType={'text'} value={requestState['user_pey_instalment']} thousandSeparator={true} prefix={' ریال'} />

                                                        }
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12}>

                                                    {(user_pey_detail)?

                                                            (
                                                        <div>
                                                            <Table className={classes.table} aria-label="simple table">
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell align="center">
                                                                            <FloatingLabelInput
                                                                                type="currency"
                                                                                placeholder=" مبلغ"
                                                                                handleInputt={this.handleChangeAmountAllCheck}
                                                                                value={amountAllCheck}
                                                                            />
                                                                        </TableCell>
                                                                        <TableCell align="center">

                                                                            <Button   variant="outlined" color="primary"  onClick={(e) => {
                                                                                var vartemp =requestState;

                                                                                for (var k = 0; k < vartemp.user_pey_detail.length; k++) {

                                                                                    vartemp.user_pey_detail[k].user_pey_amount =amountAllCheck
                                                                                }
                                                                                console.log(this.props)
                                                                                this.props.props.dispatch({
                                                                                    type: 'STATEREQUEST',
                                                                                    state: vartemp
                                                                                })

                                                                                this.setState({ snackstr: "",showSnack:false,snackMode:"error" });
                                                                            }}
                                                                            >
                                                                                اعمال برای همه اقساط
                                                                            </Button>
                                                                            </TableCell>
                                                                             <TableCell>
                                                                             </TableCell>
                                                                        <TableCell align="center">تاریخ
                                                                            <Calendar
                                                                                renderInput={this.renderCustomInputCheck} // render a custom input
                                                                                value={selectedDayCheck}
                                                                                onChange={this.setSelectedDayCheck}
                                                                                locale="fa"
                                                                                shouldHighlightWeekends
                                                                            />
                                                                        </TableCell>
                                                                        <TableCell align="center">

                                                                            <Button   variant="outlined" color="primary"  onClick={(e) => {
                                                                                console.log(selectedDayCheck);

                                                                                var vartemp =requestState;

                                                                                for (var k = 0; k < vartemp.user_pey_detail.length; k++) {
                                                                                    var month= selectedDayCheck.month+k;
                                                                                    var year= selectedDayCheck.year;
                                                                                    if(month>12){month=month-12;year++;}
                                                                                    console.log(month,year)

                                                                                    vartemp.user_pey_detail[k].instalment_check_date = Moment(JDate.toGregorian(year, month, selectedDayCheck.day)).format('YYYY-MM-DD h:mm:ss')
                                                                                }
                                                                                console.log(this.props)
                                                                                this.props.props.dispatch({
                                                                                    type: 'STATEREQUEST',
                                                                                    state: vartemp
                                                                                })

                                                                                this.setState({ snackstr: "",showSnack:false,snackMode:"error" });
                                                                            }}
                                                                            >
                                                                                تغییر تاریخ ها
                                                                            </Button>
                                                                        </TableCell>

                                                                        <TableCell align="center">

                                                                            <Button   variant="outlined" color="primary"  onClick={(e) => {

                                                                                for (var k = 0; k < requestState.user_pey_detail.length; k++) {
                                                                                    this.changeDateNumChake(requestState.user_pey_detail[k], requestState['request_id']);
                                                                                        }

                                                                            }}
                                                                            >
                                                                                  اعمال همه تغییر ها
                                                                            </Button>
                                                                        </TableCell>

                                                                        </TableRow>
                                                                    <TableRow>
                                                                        <TableCell align="center"> مبلغ پرداخت
                                                                            شده
                                                                        </TableCell>
                                                                        <TableCell align="center">

                                                                            توضیحات</TableCell>
                                                                        <TableCell align="center">تصویر </TableCell>
                                                                        <TableCell align="center">تاریخ

                                                                        </TableCell>
                                                                        <TableCell align="center">
                                                                            شماره چک

                                                                        </TableCell>
                                                                        <TableCell align="center"> </TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {
                                                                        user_pey_detail.map((row, index) => {
                                                                                return (
                                                                                    <Check
                                                                                        key={index}
                                                                                        check={row}

                                                                                        setImageModel={(imgt, img, desc) => {
                                                                                            this.setImageModel(imgt, img, desc);
                                                                                        }}

                                                                                        changeDateNumChake={(check) => {
                                                                                            this.changeDateNumChake(check, requestState['request_id']);
                                                                                        }}
                                                                                        deleteDateNumChake={(check) => {
                                                                                            this.deleteDateNumChake(check, requestState['request_id']);
                                                                                        }}

                                                                                    />

                                                                                )
                                                                            }
                                                                        )

                                                                    }
                                                                    <NewCheck
                                                                        optionInstalmentMode={optionInstalmentMode}
                                                                        changeDateNumChake={(check) => {
                                                                            this.changeNewChake(check, requestState['request_id']);
                                                                            console.log(check)
                                                                        }}

                                                                    />
                                                                </TableBody>

                                                            </Table>
                                                        </div>)

                                                        : (null)}
                                                </Grid>


                                            </Grid>

                                        </Container>
                                    </Paper>
                                </Collapse>




                                <Collapse in={showPaper[2]}>
                                    <Paper elevation={4} style={{marginTop:"15px"}}>
                                        <Container component="main" maxWidth="lg">
                                            <Grid container spacing={3}>

                                                <Grid item xs={12}>
                                                    <Divider/>
                                                </Grid>
                                            </Grid>

                                            {(request_stats)?

                                                <TableContainer component={Paper}>
                                                    <Table className={classes.table} aria-label="simple table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell style={{ minWidth: 60 }} align="center">وضعیت</TableCell>
                                                                <TableCell style={{ minWidth: 30 }} align="center">تاریخ</TableCell>
                                                                <TableCell style={{ minWidth: 100 }} align="center">توضیحات </TableCell>
                                                                <TableCell style={{ minWidth: 30 }} align="center">کد نماینده </TableCell>
                                                                <TableCell style={{ minWidth: 30 }} align="center">نماینده</TableCell>
                                                                <TableCell style={{ minWidth: 30 }} align="center">کارمند</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {request_stats.map(row =>
                                                            {
                                                                var varmoment=Moment(row.staterequest_timestamp, 'YYYY-M-D HH:mm:ss')
                                                                var date=new Date(parseInt(varmoment.format('x')));
                                                                var jdate1=new JDate(date);
                                                                var dateMinStr=jdate1.format('YYYY/MM/DD')+"ساعت "+varmoment.format('HH:mm');

                                                                return(
                                                                    <TableRow key={row.staterequest_id}>
                                                                        <TableCell align="center"> {row.request_state_name}</TableCell>
                                                                        <TableCell align="center">{dateMinStr}</TableCell>
                                                                        <TableCell align="center">{row.staterequest_desc}</TableCell>
                                                                        <TableCell align="center">{row.agent_code}</TableCell>
                                                                        <TableCell align="center">{(row.agent_name)?row.agent_name+" "+row.agent_family:''}</TableCell>
                                                                        <TableCell align="center">{(row.employee_name)?row.employee_name+" "+row.employee_family:''}</TableCell>

                                                                    </TableRow>
                                                                )})}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>

                                                :null}
                                        </Container>

                                    </Paper>
                                </Collapse>



                                <Collapse in={showPaper[3]}>
                                    <Paper elevation={4} style={{marginTop:"15px"}}>
                                        <Container component="main" maxWidth="lg">
                                            <Grid container spacing={3}>
                                                <Grid item xs={12}>
                                                    <Typography align='center' variant="h6"  >
                                                        عکس های سفارش
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Divider/>
                                                </Grid>
                                            </Grid>

                                            {(request_image)?

                                                <TableContainer component={Paper}>
                                                    <Table className={classes.table} aria-label="simple table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell style={{ minWidth: 60 }} align="center">نام عکس</TableCell>
                                                                <TableCell style={{ minWidth: 100 }} align="center">توضیحات</TableCell>
                                                                <TableCell style={{ minWidth: 30 }} align="center">عکس </TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {request_image.map(row =>
                                                            {
                                                                return(
                                                                    <TableRow key={row.image_name}>
                                                                        <TableCell align="center"> {row.image_name}</TableCell>
                                                                        <TableCell align="center">{row.image_desc}</TableCell>

                                                                        <TableCell align="center">
                                                                            <div style={{width:'100%',textAlign:'center'}}>
                                                                                <Avatar  variant='rounded' alt="Remy Sharp" src={row.image_tumb_url}
                                                                                         onClick={() => {
                                                                                             this.setImageModel(row.image_tumb_url, row.image_url,row.image_name);
                                                                                         }}
                                                                                />
                                                                            </div>
                                                                        </TableCell>

                                                                    </TableRow>
                                                                )})}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>

                                                :null}
                                        </Container>

                                    </Paper>
                                </Collapse>

                                <Collapse in={showPaper[7]}>
                                    <Paper elevation={4} style={{marginTop:"15px"}}>
                                        <Container component="main" maxWidth="lg">
                                            <Grid container spacing={3}>
                                                <Grid item xs={12}>
                                                    <Typography align='center' variant="h6"  >
                                                        عکس های بازدید
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Divider/>
                                                </Grid>

                                                {(visit_image)?
                                                    <Grid item xs={12}>
                                                        {visit_image.map(row =>
                                                        {
                                                            var images=row.images_visit;
                                                            console.log(images)
                                                            return(
                                                                <Grid container spacing={3}>
                                                                    <Grid item xs={3}>
                                                                        <Typography align='center' variant="h7"  >
                                                                            {" نام بازدید کننده:"+row['user_name']+" "+row['user_family']}
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={3}>
                                                                        <Typography align='center' variant="h7"  >
                                                                            {" همراه بازدید کننده:"+row['user_mobile']}

                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={6}>
                                                                        <Typography align='center' variant="h7"  >
                                                                            <a href={row.request_visit_vedio_url}>ویدیو</a>
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12}>
                                                                        <TableContainer component={Paper}>
                                                                            <Table className={classes.table} aria-label="simple table">
                                                                                <TableHead>
                                                                                    <TableRow>
                                                                                        <TableCell style={{ minWidth: 60 }} align="center">نام عکس</TableCell>
                                                                                        <TableCell style={{ minWidth: 100 }} align="center">توضیحات</TableCell>
                                                                                        <TableCell style={{ minWidth: 30 }} align="center">عکس </TableCell>
                                                                                    </TableRow>
                                                                                </TableHead>
                                                                                <TableBody>
                                                                                    {images.map(row2 =>
                                                                                    {
                                                                                        return(
                                                                                            <TableRow key={row2.image_name}>
                                                                                                <TableCell align="center"> {row2.image_name}</TableCell>
                                                                                                <TableCell align="center">{row2.image_desc}</TableCell>

                                                                                                <TableCell align="center">
                                                                                                    <div style={{width:'100%',textAlign:'center'}}>
                                                                                                        <Avatar  variant='rounded' alt="Remy Sharp" src={row2.image_tumb_url}
                                                                                                                 onClick={() => {
                                                                                                                     this.setImageModel(row2.image_tumb_url, row2.image_url,row2.image_name);
                                                                                                                 }}
                                                                                                        />
                                                                                                    </div>
                                                                                                </TableCell>

                                                                                            </TableRow>

                                                                                        )})}
                                                                                </TableBody>
                                                                            </Table>
                                                                        </TableContainer>
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <Divider/>
                                                                    </Grid>
                                                                </Grid>
                                                            )
                                                        })
                                                        }
                                                    </Grid>



                                                    :null}
                                            </Grid>

                                        </Container>

                                    </Paper>
                                </Collapse>


                                <Collapse in={showPaper[4]}>
                                    <Paper elevation={4} style={{marginTop:"15px"}}>
                                        <Container component="main" maxWidth="lg">

                                            {(request_ready)?
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h6" >جزئیات صدور بیمه نامه</Typography>
                                                    </Grid>
                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12} sm={12}>

                                                            <Grid container spacing={3}>
                                                                <Grid item xs={6}>
                                                                    <Typography variant="h7" >{'تاریخ شروع : '}
                                                                        {new JDate(new Date(parseInt(Moment(request_ready['requst_ready_start_date'], 'YYYY-M-D HH:mm:ss').format('x')))).format('YYYY/MM/DD ')}
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Typography variant="h7" >{'تاریخ پایان: '}
                                                                        {new JDate(new Date(parseInt(Moment(request_ready['requst_ready_end_date'], 'YYYY-M-D HH:mm:ss').format('x')))).format('YYYY/MM/DD ')}
                                                                    </Typography>
                                                                </Grid>


                                                                <Grid item xs={6}>
                                                                    <Typography variant="h7" >{'قیمت نهایی: '}{request_ready['requst_ready_end_price']}</Typography>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Typography variant="h7" >{'شماره بیمه نامه: '}{request_ready['requst_ready_num_ins']}</Typography>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Typography variant="h7" >{'کد یکتا بیمه نامه: '}{request_ready['requst_ready_code_yekta']}</Typography>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Typography variant="h7" >{'کد رایانه بیمه نامه: '}{request_ready['requst_ready_code_rayane']}</Typography>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Typography variant="h7" >{'   مبلغی که شامل کارمزد نمیشود: '}{request_ready['requst_ready_code_penalty']}</Typography>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Typography variant="h7" >{'کد ملی بیمه گذار: '}{request_ready['requst_ready_code_insurer']}</Typography>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Typography variant="h7" >{'نام بیمه گذار: '}{request_ready['requst_ready_name_insurer']}</Typography>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Typography variant="h7" >{'نحوه تسویه: '}{request_ready['request_ready_clearing_mode_name']}</Typography>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    {(request_ready['requst_ready_employee_id']&&optionEmployee.find((x) => x.value === request_ready['requst_ready_employee_id']))?
                                                                        <Typography variant="h7" >{' نام کارمند: '}{optionEmployee.find((x) => x.value === request_ready['requst_ready_employee_id']).label}</Typography>
                                                                        :""}
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <Typography variant="h7" >{'توضیحات صدور : '}{request_ready['requst_suspend_desc']}</Typography>
                                                                </Grid>

                                                            </Grid>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            {(request_ready_file_tb)?

                                                                <TableContainer component={Paper}>
                                                                    <Table className={classes.table} aria-label="simple table">
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell style={{ minWidth: 100 }} align="center">توضیحات</TableCell>
                                                                                <TableCell style={{ minWidth: 30 }} align="center">لینک دانلود </TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {request_ready_file_tb.map(row =>
                                                                            {
                                                                                return(
                                                                                    <TableRow key={row.request_file_desc}>
                                                                                        <TableCell align="center"> {row.request_file_desc}</TableCell>

                                                                                        <TableCell align="center">
                                                                                            <a href={row.request_file_url}>دانلود</a>
                                                                                        </TableCell>

                                                                                    </TableRow>
                                                                                )})}
                                                                        </TableBody>
                                                                    </Table>
                                                                </TableContainer>

                                                                :null}
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>



                                                            {(request_ready_image_tb)?

                                                                <TableContainer component={Paper}>
                                                                    <Table className={classes.table} aria-label="simple table">
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell style={{ minWidth: 60 }} align="center">نام عکس</TableCell>
                                                                                <TableCell style={{ minWidth: 100 }} align="center">توضیحات</TableCell>
                                                                                <TableCell style={{ minWidth: 30 }} align="center">عکس </TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {request_ready_image_tb.map(row =>
                                                                            {
                                                                                return(
                                                                                    <TableRow key={row.image_name}>
                                                                                        <TableCell align="center"> {row.image_name}</TableCell>
                                                                                        <TableCell align="center">{row.image_desc}</TableCell>

                                                                                        <TableCell align="center">
                                                                                            <div style={{width:'100%',textAlign:'center'}}>
                                                                                                <Avatar  variant='rounded' alt="Remy Sharp" src={row.image_tumb_url}
                                                                                                         onClick={() => {
                                                                                                             this.setImageModel(row.image_tumb_url, row.image_url,row.image_name);
                                                                                                         }}
                                                                                                />
                                                                                            </div>
                                                                                        </TableCell>

                                                                                    </TableRow>
                                                                                )})}
                                                                        </TableBody>
                                                                    </Table>
                                                                </TableContainer>

                                                                :null}

                                                        </Grid>
                                                    </Grid>


                                                </Grid>
                                                :null}
                                        </Container>
                                    </Paper>

                                    <Paper elevation={4} style={{marginTop:"15px"}}>
                                        <Container component="main" maxWidth="lg">

                                            {(request_delivered)?
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h6" >جزئیات ارسال بیمه نامه</Typography>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Typography variant="h7" >{'تاریخ ارسال : '}
                                                            {
                                                                new JDate(new Date(parseInt(Moment(request_delivered['request_delivered_timesatmp'], 'YYYY-M-D HH:mm:ss').format('x')))).format('YYYY/MM/DD ')+"ساعت "+
                                                                Moment(request_delivered['request_delivered_timesatmp'], 'YYYY-M-D HH:mm:ss').format('HH:mm')
                                                            }
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Typography variant="h7" >{'روش ارسال: '}{request_delivered['request_delivered_mode']}</Typography>
                                                    </Grid>



                                                    <Grid item xs={6}>
                                                        <Typography variant="h7" >{'َشهر: '}{request_delivered['request_delivered_city']}</Typography>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Typography variant="h7" >{'استان : '}{request_delivered['request_delivered_state']}</Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h7" >{'توضیحات ارسال: '}{request_delivered['request_delivered_dsc']}</Typography>
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <Typography variant="h7" >{'رسید تحویل بیمه نامه : '}</Typography>

                                                        <Avatar  variant='rounded' alt="Remy Sharp" src={request_delivered['user_pey_image_turl']}
                                                                 onClick={() => {
                                                                     this.setImageModel(request_delivered['user_pey_image_turl'], request_delivered['user_pey_image_url'],' رسید تحویل بیمه نامه');
                                                                 }}
                                                        />
                                                    </Grid>

                                                </Grid>
                                                :null}


                                        </Container>
                                    </Paper>
                                </Collapse>
                                <Snackbar
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left'}}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000} >
                                    <Alert severity={snackMode}>
                                        {snackstr}
                                    </Alert>
                                </Snackbar>

                            </Grid>
                        </Grid>

                        {
                            this.state.openImageBox && (
                                <Lightbox
                                    medium={urlToLargeImageFile}
                                    large={urlToLargeImageFile}
                                    small={urlToLargeImageFile}
                                    smallSrcSet={urlToHugeImageFile}
                                    alt={descImageFile}
                                    onClose={this.closeLightbox}
                                    showRotate={true}
                                    hideZoom={false}
                                />
                            )
                        }
                    </Container>

                    :
                    <Container component="main" maxWidth="lg">
                        <div style={{width:'100%',textAlign:'center'}}>
                            <Redirect to="/archiveorderpay"/>


                        </div>

                    </Container>

                }
                <Container component="main" maxWidth="lg">

                    <InsureInformation ReqId={requestState['request_id']} />


                    <Container maxWidth="lg">


                        <RequestConcil request_id={requestState['request_id']}  agent_id={requestState['agent_id']} />
                    </Container>


                </Container>

            </div>
        );
    }
}

function Check({check,setImageModel,changeDateNumChake,deleteDateNumChake}){
 //   const [checkState, setCheckState] = useState(check);
  // const [checkDate, setCheckDate] = useState(jdate2);
 //   console.log(check);
  //  if(check.user_pey_amount!==checkState.user_pey_amount||check.instalment_check_date!==checkState.instalment_check_date) {
  //      setCheckState(check);
 //   }

    const renderCustomInput = ({ ref }) => {
        var jdate2=null;
        if(check.instalment_check_date!==null&&check.instalment_check_date!==''){
            var varmoment2=Moment(check.instalment_check_date, 'YYYY-M-D HH:mm:ss')
            var date2=new Date(parseInt(varmoment2.format('x')));
            jdate2=new JDate(date2);
            jdate2={ day: parseInt(jdate2.format('DD')), month: parseInt(jdate2.format('MM')), year: parseInt(jdate2.format('YYYY')) };
            console.log(jdate2)
        }
       return (
            <OutlinedInput
                readOnly
                ref={ref} // necessary
                placeholder="تاریخ تعهد"
                style={{
                    fontSize: '13px',
                    direction: 'ltr'
                }}
                value={jdate2 ? (jdate2.year + '/' + jdate2.month + '/' + jdate2.day) : ''}
                className="my-custom-input-class" // a styling class

                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            onClick={() => {
                                jdate2=null;
                            }}
                        >
                            <HighlightOffIcon/>
                        </IconButton>
                    </InputAdornment>
                }
            />
        )
    }
    console.log(check);
    return(
        <TableRow key={check.instalment_check_id}>
            <TableCell align="center">
                <FloatingLabelInput type={"currency"} placeholder=""
                                    value={check.user_pey_amount}
                                    handleInputt={(event) => {
                                        check.user_pey_amount=event
                   // setCheckState({...checkState,user_pey_amount:event                    });
                }}  />

            </TableCell>
            <TableCell align="center">{check.user_pey_desc}</TableCell>
            <TableCell align="center">
                <Avatar  variant='rounded' alt="Remy Sharp" src={check.user_pey_image_turl}
                         onClick={() => {
                             setImageModel(check.user_pey_image_turl, check.user_pey_image_url,'عکس چک های سفارش ');
                             console.log('dsds');
                         }}
                />
            </TableCell>
            <TableCell align="center">

                <Calendar
                 //  value={check.instalment_check_date}
                    onChange={(event) => {//setCheckDate(event);
                        check.instalment_check_date=Moment(JDate.toGregorian(event.year, event.month, event.day)).format('YYYY-MM-DD h:mm:ss');
                     //   setCheckState({...checkState,instalment_check_date:Moment(JDate.toGregorian(event.year, event.month, event.day)).format('YYYY-MM-DD h:mm:ss')});
                    }}
                    renderInput={renderCustomInput} // render a custom input
                    locale="fa"
                    shouldHighlightWeekends
                />
            </TableCell>
            <TableCell align="center">

                <FloatingLabelInput placeholder="" type={"number"}  value={check.instalment_check_num}
                                    handleInputt={(event) => {
                                       check.instalment_check_num=event
              //      setCheckState({...checkState,instalment_check_num:event.target.value});
                                    }}
                />


            </TableCell>


            <TableCell align="center">
                <Button   variant="outlined" color="primary" onClick={(event) => {
                    changeDateNumChake(check);


                }}>
                    تغییر
                </Button>

                <Button   variant="outlined" color="primary" onClick={(event) => {
                    deleteDateNumChake(check);

                }}>
                    حذف
                </Button>

            </TableCell>


        </TableRow>
    )

}

function NewCheck({changeDateNumChake,optionInstalmentMode}){

    const [checkState, setCheckState] = useState({
        instalment_check_id:'',
        user_pey_amount:'',
        user_pey_desc:'',
        instalment_check_date:''
    });
    const [checkDate, setCheckDate] = useState();



    const renderCustomInput = ({ ref }) => (
        <OutlinedInput
            readOnly
            ref={ref} // necessary
            placeholder="تاریخ تعهد"
            style={{
                fontSize:'13px',
                direction:'ltr'
            }}
            value={checkDate ? (checkDate.year+'/'+checkDate.month+'/'+checkDate.day):''}
            className="my-custom-input-class" // a styling class

            endAdornment={
                <InputAdornment position="end">
                    <IconButton
                        onClick={() => {setCheckDate(null)}}
                    >
                        <HighlightOffIcon/>
                    </IconButton>
                </InputAdornment>
            }
        />
    )
    console.log(checkState);
    return(
        <TableRow key={checkState.instalment_check_id}>
            <TableCell align="center">
                <FloatingLabelInput type={"currency"} placeholder="" value={checkState.user_pey_amount} handleInputt={(event) => {
                    setCheckState({...checkState,user_pey_amount:event});
                }}  />

            </TableCell>
            <TableCell align="center">
                <FloatingLabelInput placeholder="" value={checkState.user_pey_desc} handleInputt={(event) => {
                    setCheckState({...checkState,user_pey_desc:event.target.value});
                }}  />
            </TableCell>
            <TableCell align="center">
                <Select  isSearchable={true}
                         className="adapter-txtsize"
                         placeholder ={'شرکت بیمه'}
                         value={checkState.installment_mode}
                         onChange={(event) => {
                             setCheckState({...checkState,installment_mode:event});
                         }}
                         options={optionInstalmentMode} />


            </TableCell>
            <TableCell align="center">

                <Calendar
                    value={checkDate}
                    onChange={(event) => {setCheckDate(event);
                        setCheckState({...checkState,instalment_check_date:event});
                    }}
                    renderInput={renderCustomInput} // render a custom input
                    locale="fa"
                    shouldHighlightWeekends
                />
            </TableCell>
            <TableCell align="center">

                <FloatingLabelInput placeholder="" value={checkState.instalment_check_num} handleInputt={(event) => {
                    setCheckState({...checkState,instalment_check_num:event.target.value});
                }}  />


            </TableCell>


            <TableCell align="center">
                <Button   variant="outlined" color="primary" onClick={(event) => {
                    console.log(checkState)
                   changeDateNumChake(checkState);
                    setCheckState({
                        instalment_check_id:'',
                        user_pey_amount:'',
                        user_pey_desc:'',
                        instalment_check_date:'',
                        instalment_check_num:''
                    })
                }}>
                    اضافه کردن
                </Button>
            </TableCell>


        </TableRow>
    )

}

const mapStateToPropsAppContainer = (state) => {
    return {
        requestState:state.requestState.requestState,
    }
}


export default withStyles(styles)(connect(mapStateToPropsAppContainer)(RequestDetail));
